import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { getLanguageCode } from '../i18n.js';
import { modal$ } from '../stores/store-main.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { SBB_URL_BY_LANG } from './constants.js';
export const heightProfilePDF = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      id="Rechteck_3243"
      data-name="Rechteck 3243"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="icons8-open_document"
      d="M6,2A2.013,2.013,0,0,0,4,4V20a2.013,2.013,0,0,0,2,2H16.172l-1.586-1.586L14.172,20H6V4h7V9h5v3h2V8L14,2ZM18,14v4H15l4,4,4-4H20V14Z"
      transform="translate(-1)"
    />
  </svg>
`;
export const signalisationOneDirectionSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    alt=""
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rechteck_4770"
          data-name="Rechteck 4770"
          width="19.94"
          height="10.95"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <rect
      id="Rechteck_4769"
      data-name="Rechteck 4769"
      width="24"
      height="24"
      fill="none"
    />
    <g id="Gruppe_12643" data-name="Gruppe 12643" transform="translate(2 7)">
      <g id="Gruppe_12642" data-name="Gruppe 12642" clip-path="url(#clip-path)">
        <path
          id="Pfad_13725"
          data-name="Pfad 13725"
          d="M14.255,10.95H.975A.975.975,0,0,1,0,9.975v-9A.975.975,0,0,1,.975,0h13.24a.981.981,0,0,1,.671.267l4.75,4.5a.976.976,0,0,1,0,1.413l-4.71,4.5a.978.978,0,0,1-.674.27M1.95,9H13.865l3.686-3.523L13.827,1.95H1.95ZM3.995,2.975h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1h-3a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1"
        />
      </g>
    </g>
  </svg>
`;
export const notificationSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      id="Rechteck_3197"
      data-name="Rechteck 3197"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="icons8-info"
      d="M12,2A10,10,0,1,0,22,12,10.015,10.015,0,0,0,12,2Zm0,2a8,8,0,1,1-8,8A7.985,7.985,0,0,1,12,4ZM11,7V9h2V7Zm0,4v6h2V11Z"
    />
  </svg>
`;
export const angleUpSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.07 8 6 14.07l1.5 1.5L12.07 11l4.57 4.57 1.5-1.5Z" />
  </svg>
`;
export const triangleUpSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 12,6.3697004 5.49869,17.630299 c 4.1168741,0 9.165214,0 13.00262,0 z"
    />
  </svg>
`;
export const filterSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2a3.008 3.008 0 0 0-2.812 2H2v2h5.188A2.993 2.993 0 1 0 10 2Zm0 2a1 1 0 1 1-1 1 .985.985 0 0 1 1-1Zm5 0v2h7V4Zm0 5a3.008 3.008 0 0 0-2.812 2H2v2h10.188A2.993 2.993 0 1 0 15 9Zm0 2a1 1 0 1 1-1 1 .985.985 0 0 1 1-1Zm5 0v2h2v-2ZM7 16a3.008 3.008 0 0 0-2.812 2H2v2h2.188A2.993 2.993 0 1 0 7 16Zm0 2a1 1 0 1 1-1 1 .985.985 0 0 1 1-1Zm5 0v2h10v-2Z"
    />
  </svg>
`;
export const filterDirtySvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 3a3 3 0 1 1-3-3 3 3 0 0 1 3 3" fill="#d4021c" />
    <path
      d="M17.928 6h-2.926V4h1.453a4.008 4.008 0 0 0 1.473 2m-5.74 7H1.994v-2h10.194a2.99 2.99 0 1 1 0 2m1.814-1a1 1 0 1 0 1-1h-.03a.986.986 0 0 0-.971 1m-2 8h10.005v-2H12Zm8-7h2v-2h-2ZM9.825 18a3 3 0 0 1-5.642 2.014H1.994v-2h2.189A2.992 2.992 0 0 1 9.825 18m-1.831 1.01a1 1 0 0 0-1-1h-.03a.986.986 0 0 0-.971 1 1 1 0 0 0 2 0M7.185 6H1.994V4h5.191a2.99 2.99 0 1 1 0 2m1.809-1a1 1 0 1 0 1-1h-.03a.986.986 0 0 0-.97 1"
    />
  </svg>
`;
export const searchSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 4a14 14 0 1 0 9.148 24.563l.852.852V32l12 12 4-4-12-12h-2.586l-.852-.852A13.971 13.971 0 0 0 18 4Zm0 4A10 10 0 1 1 8 18 9.97 9.97 0 0 1 18 8Z"
    />
  </svg>
`;
export const userSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
  >
    <path
      d="M43.734 45.707H39.76a15.894 15.894 0 1 0-31.787 0H4a19.808 19.808 0 0 1 12.059-18.3 13.907 13.907 0 1 1 15.616 0 19.808 19.808 0 0 1 12.059 18.3ZM23.867 5.973a9.933 9.933 0 1 0 9.933 9.934 9.945 9.945 0 0 0-9.933-9.934Z"
    />
  </svg>
`;
export const userDirtySvg = (classes = 'w-4 h-4', pointClass = '') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
  >
    <path class="${pointClass}" d="M48 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6" />
    <path
      d="M43.734 45.707H39.76a15.894 15.894 0 1 0-31.787 0H4a19.808 19.808 0 0 1 12.059-18.3 13.907 13.907 0 1 1 15.616 0 19.808 19.808 0 0 1 12.059 18.3ZM23.867 5.973a9.933 9.933 0 1 0 9.933 9.934 9.945 9.945 0 0 0-9.933-9.934Z"
    />
  </svg>
`;
export const trekkingSvg = ({ classes = 'w-4 h-4', ariaLabel = '', alt = '' }) => html ` <svg
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    class="${classes}"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <defs>
      <style>
        .cls-1 {
          fill: none;
        }
        .cls-2 {
          clip-path: url(#clippath);
        }
        .cls-3 {
          fill: #fff;
        }
        .cls-4 {
          fill: #609f26;
        }
      </style>
      <clipPath id="clippath">
        <rect class="cls-1" x=".03" y=".02" width="24" height="24" />
      </clipPath>
    </defs>
    <g class="cls-2">
      <path
        class="cls-4"
        d="M.03,12.02C.03,5.39,5.4,.02,12.03,.02s12,5.37,12,12-5.37,12-12,12S.03,18.64,.03,12.02"
      />
      <path
        class="cls-3"
        d="M12.26,2.38c.78,0,1.39,.67,1.39,1.42s-.58,1.43-1.36,1.43c-.87,0-1.39-.71-1.39-1.45s.52-1.4,1.35-1.4m-.38,3.1c-.16,0-.35,.04-.5,.08-.11,.04-.29,.17-.32,.17h-1.77c-.21,0-.62,.21-.75,.3-.06,.04-.05,.09-.05,.14,0,.08,.04,.23,.2,.23,.1,0,.44-.23,.58-.23h.82c.04,.05,.1,.1,.1,.15,0,.04-.04,.13-.1,.17h-.74c-.14,0-.49,.2-.55,.24-.08,.06-.17,.13-.22,.2-.13,.17-.16,.41-.2,.58-.05,.2-.11,.4-.16,.6-.05,.18-.35,1.36-.35,1.51,0,.14,.02,.3,.12,.45,.2,.27,.42,.46,.65,.67,.13,.12,.57,.68,.82,.68h.95l.04,.04v.31h2.91s.01-.03,.03-.04v-.85l1.13,1.21-.53,2.08-.57-2.1h-2.99c-.3,.95-.53,1.95-.8,2.95-.21,.75-.38,1.52-.57,2.26-.14,.55-.71,2.6-.71,2.8,0,.5,.41,.96,.93,.96,.27,0,.59-.09,.81-.46,.13-.21,.14-.44,.2-.63,.11-.38,.21-.79,.31-1.17,.03-.14,.07-.29,.11-.43,.02-.06,0-.14,.02-.2,.38-1.51,.8-3.02,1.18-4.53,.02-.08,.03-.17,.04-.25,0,.01,.02,.04,.03,.05,.13,.46,.25,.93,.37,1.38,0,.04,.01,.09,.02,.13,.25,.93,.52,1.88,.75,2.81l-.76,2.99c0,.12,.07,.23,.19,.23,.05,0,.18-.05,.2-.12,.18-.76,.39-1.52,.57-2.26,.19,.58,.3,1.22,.51,1.81,.02,.06,.02,.14,.05,.2,.04,.07,.1,.14,.15,.18,.13,.12,.42,.19,.58,.19,.52,0,.93-.41,.93-.95,0-.03,0-.2-.03-.3-.43-1.58-1.31-4.72-1.31-4.76s.24-.95,.37-1.43c.12-.43,.2-.89,.35-1.3,.19,.04,.42,0,.59-.1,.23-.16,.33-.37,.35-.56,0-.01,.02,.02,.02-.02v-.35s-.03-.03-.04-.04c-.08-.27-.4-.58-.59-.76-.42-.43-.91-.91-1.25-1.29-.21-.24-.65-.67-.65-.7v-1.63s-.05-.25-.1-.36c-.28-.67-.9-.95-1.39-.95"
      />
    </g>
    <rect class="cls-1" x="0" width="24" height="24" />
    <rect class="cls-1" x="0" width="24" height="24" />
  </svg>`;
export const poiPointSvg = ({ classes = 'w-4 h-4', fill = '#0074d9', ariaLabel = '', alt = '', number = 0, }) => html ` <svg
    class="${classes}"
    alt=${alt}
    aria-label=${ariaLabel}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 33"
    fill="${fill}"
  >
    <path
      fill="currentFill"
      stroke="white"
      stroke-width="2"
      paint-order="stroke"
      d="M18 8.177c-5 0-9.5 3-9.5 9 0 4 9.5 24 9.5 24s9.5-20 9.5-24c0-6-4.5-9-9.5-9Z"
      transform="translate(-8, -7)"
    />
    <text
      x="10"
      y="16"
      text-anchor="middle"
      font-family="Inter Variable"
      font-weight="bold"
      font-size="14"
      fill="white"
    >
      ${number ? number : ''}
    </text>
  </svg>`;
export const maxHeightSvg = ({ classes = 'w-4 h-24', ariaLabel = '', alt = '', }) => html ` <svg
    id="i_plus_anzeige_hoehemeter_max"
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 24 24"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <rect
      id="Rechteck_3792"
      data-name="Rechteck 3792"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="Pfad_13111"
      data-name="Pfad 13111"
      d="M603.587-10047.04l3.089-6.077,2.26,4.546,6.852-12.624,7.938,14.155"
      transform="translate(-601.661 10066.883)"
      fill="none"
      stroke="#868e96"
      stroke-width="2"
    />
    <circle
      id="Ellipse_738"
      data-name="Ellipse 738"
      cx="2"
      cy="2"
      r="2"
      transform="translate(12 2)"
    />
  </svg>`;
export const minHeightSvg = ({ classes = 'w-4 h-24', ariaLabel = '', alt = '', }) => html ` <svg
    id="i_plus_anzeige_hoehemeter_max"
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 24 24"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <rect
      id="Rechteck_3795"
      data-name="Rechteck 3795"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="Pfad_13112"
      data-name="Pfad 13112"
      d="M602.533-10045.241l4.144-7.876,5.866,10.5,7.5-10.5"
      transform="translate(-599.727 10060.117)"
      fill="none"
      stroke="#868e96"
      stroke-width="2"
    />
    <circle
      id="Ellipse_739"
      data-name="Ellipse 739"
      cx="2"
      cy="2"
      r="2"
      transform="translate(11 16)"
    />
  </svg>`;
export const tagSvg = ({ classes = 'w-4 h-24', ariaLabel = '', alt = '' }) => html ` <svg
    id="i_plus_anzeige_hoehemeter_max"
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 24 24"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <rect
      id="Rechteck_4131"
      data-name="Rechteck 4131"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="Pfad_13755"
      data-name="Pfad 13755"
      d="M21.62,7.25c-1.16-.21-1.14-.53-1.09-1.59a2.9,2.9,0,0,0-.85-2.65,2.424,2.424,0,0,0-2.22-.51,5.98,5.98,0,0,0-2.93,2.51l-.51-.53a1,1,0,0,0-.91-.28l-2.59.52a.967.967,0,0,0-.52.29L1.7,13.6a1,1,0,0,0-.03,1.36l5.96,6.71a.938.938,0,0,0,.71.33h.03a.984.984,0,0,0,.7-.29l8.81-8.62a1.031,1.031,0,0,0,.28-.51l.55-2.65a.993.993,0,0,0-.26-.9L15.74,6.25a4.9,4.9,0,0,1,2.15-2.11.742.742,0,0,1,.72.19c.24.2.25.54.22,1.26-.05,1.08-.13,2.87,2.49,3.34a.853.853,0,1,0,.3-1.68Zm-4.98,2.8-.38,1.83L8.42,19.55,3.78,14.33l7.44-7.71,1.75-.35.48.5c-.38.69-.69,1.34-.91,1.84a1.382,1.382,0,1,0,1.64,1.35,1.407,1.407,0,0,0-.13-.58c.19-.43.41-.88.65-1.33l1.95,2.01Z"
      transform="translate(0.583 -0.416)"
    />
  </svg>`;
export const categorySvg = ({ classes = 'w-4 h-24', ariaLabel = '', alt = '' }) => html `<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    alt=${alt}
    aria-label=${ariaLabel}
    class="${classes}"
  >
    <path
      d="M1.96 14.11H12.06H1.96ZM13.02 14.11C13.02 13.58 12.59 13.15 12.06 13.15H1.96C1.43 13.15 1 13.58 1 14.11C1 14.64 1.43 15.07 1.96 15.07H12.06C12.59 15.07 13.02 14.64 13.02 14.11ZM1.97 17.98H12.07H1.97ZM13.03 17.98C13.03 17.45 12.6 17.02 12.07 17.02H1.97C1.44 17.02 1.01 17.45 1.01 17.98C1.01 18.51 1.44 18.94 1.97 18.94H12.07C12.6 18.94 13.03 18.51 13.03 17.98ZM2.03 21.96H12.13H2.03ZM13.09 21.96C13.09 21.43 12.66 21 12.13 21H2.03C1.5 21 1.07 21.43 1.07 21.96C1.07 22.49 1.5 22.92 2.03 22.92H12.13C12.66 22.92 13.09 22.49 13.09 21.96ZM22.02 5V16.99C22.02 17.54 21.57 17.99 21.02 17.99H18.96V20.95C18.96 21.49 18.53 21.94 17.98 21.95L14.1 22.04L14.06 20.04L16.97 19.98V10.25H9.99C9.75 10.25 9.53 10.17 9.35 10.01L7.31 8.29H4V11.99H1.99V7.31C1.99 6.76 2.44 6.31 2.99 6.31H4.99V3.02C4.99 2.47 5.44 2.02 5.99 2.02L10.68 2C10.92 2 11.15 2.09 11.33 2.24L13.38 4H21.02C21.57 4 22.02 4.45 22.02 5ZM20.02 6H13.01C12.77 6 12.54 5.91 12.36 5.76L10.31 4H6.99V6.28H7.66C7.85 6.27 8.13 6.36 8.31 6.51L10.35 8.23H17.96C18.51 8.23 18.96 8.68 18.96 9.23V15.98H20.02V6Z"
    />
  </svg> `;
export const toTheMapSvg = ({ classes = 'w-4 h-24', ariaLabel = '', alt = '' }) => html ` <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 24 24"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <path
      d="M10.5.75a5.4,5.4,0,0,0-5.4,5.4c0,3.858,5.4,9.9,5.4,9.9s5.4-6.042,5.4-9.9A5.4,5.4,0,0,0,10.5.75Zm0,1.8a3.6,3.6,0,0,1,3.6,3.6c0,1.809-1.875,4.823-3.6,7.073C8.77,10.978,6.9,7.964,6.9,6.15A3.6,3.6,0,0,1,10.5,2.55Zm0,1.8a1.8,1.8,0,1,0,1.8,1.8A1.8,1.8,0,0,0,10.5,4.35Zm-6.478,9L1.5,19.65h18l-2.522-6.3H14.831c-.436.656-.877,1.266-1.28,1.8h2.213l1.078,2.7H4.158l1.078-2.7H7.448c-.4-.534-.844-1.144-1.28-1.8Zm0,0"
      transform="translate(1.5 1.8)"
    />
    <rect width="24" height="24" fill="none" />
  </svg>`;
export const editSvg = ({ classes = 'w-4 h-24', ariaLabel = '', alt = '' }) => html ` <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 24 24"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <path
      d="M17.914.5a.993.993 0 0 0-.707.293L2.5 15.5v4h4L21.207 4.793a1 1 0 0 0 0-1.414L18.621.793A.993.993 0 0 0 17.914.5Zm0 2.414 1.172 1.172-1.293 1.293-1.172-1.172Zm-2.707 2.707 1.172 1.172L5.672 17.5H4.5v-1.172Zm0 0"
    />
  </svg>`;
export const deleteSvg = ({ classes = 'w-4 h-24', ariaLabel = '', alt = '' }) => html `<svg
    xmlns="http://www.w3.org/2000/svg"
    alt=${alt}
    aria-label=${ariaLabel}
    class="${classes}"
    viewBox="0 0 24 24"
  >
    <path
      d="M10 2 9 3H4v2h1v15a1.943 1.943 0 0 0 2 2h10a1.937 1.937 0 0 0 2-2V5h1V3h-5l-1-1ZM7 5h10v15H7Zm2 2v11h2V7Zm4 0v11h2V7Zm0 0"
    />
  </svg> `;
export const arrowSvg = ({ classes = 'h-[24px]', ariaLabel = '', alt = '', title = '', }) => html ` <svg
    class="${classes}"
    viewBox="3 0 18 24"
    xmlns="http://www.w3.org/2000/svg"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <title>${title}</title>
    <path
      fill-rule="evenodd"
      d="M14 5L12.5 6.5L17.0703 11.0703H3V13.0703H17.0703L12.5 17.6406L14 19.1406L21.0703 12.0703L14 5Z"
      clip-rule="evenodd"
    ></path>
  </svg>`;
export const externalLinkSvg = ({ classes = 'h-[24px]', ariaLabel = '', alt = '', title = '', }) => html `<svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 24"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <title>${title}</title>
    <path
      d="M15.0177 20H0V5H2.00236V18H15.0177V20ZM6.98822 3V5H13.5259L5.00589 13.57L6.42756 14.98L14.9976 6.36V13H17V3H6.98822Z"
    />
  </svg>`;
export const internalLinkSvg = ({ classes = 'h-[24px]', ariaLabel = '', alt = '', title = '', }) => html ` <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 24"
    alt=${alt}
    aria-label=${ariaLabel}
  >
    <title>${title}</title>
    <path
      d="M20 5.05941V18.9208H18.001V5.05941H20ZM7.45629 6.39604L12.074 10.9703L0.0100098 11.0099V12.9901L12.1539 12.9505L7.45629 17.604L8.86558 19L15.932 12L8.86558 5L7.45629 6.39604Z"
    />
  </svg>`;
export const timeSvg = (classes = 'w-4 h-4') => html ` <svg
    class="${classes}"
    alt="Durata"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11,2V4.059a9,9,0,1,0,2,0V2Zm1,4a7,7,0,1,1-7,7A6.985,6.985,0,0,1,12,6ZM11,8v5.414l3.293,3.293,1.414-1.414L13,12.586V8Z"
    />
  </svg>`;
export const fitnessSvg = (classes = 'w-4 h-4') => html ` <svg
    class="${classes}"
    alt="Forma fisica"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M7.5,3A5.5,5.5,0,0,0,2,8.5c0,4.171,4.912,8.213,6.281,9.49C9.858,19.46,12,21.35,12,21.35s2.142-1.889,3.719-3.359C17.088,16.713,22,12.671,22,8.5A5.5,5.5,0,0,0,16.5,3,5.98,5.98,0,0,0,12,5.09,5.98,5.98,0,0,0,7.5,3Zm0,2a3.978,3.978,0,0,1,2.914,1.309L12,8.373l1.586-2.064A4.007,4.007,0,0,1,16.5,5,3.5,3.5,0,0,1,20,8.5c0,2.919-3.769,6.326-5.189,7.609-.177.16-.33.3-.455.416-.751.7-1.639,1.5-2.355,2.146-.716-.642-1.605-1.446-2.355-2.146-.126-.117-.279-.257-.455-.416A25.648,25.648,0,0,1,5.379,12h.955l1.42-1.066,2,3L12.334,12h.938a2,2,0,1,0,0-2h-1.6l-1.42,1.066-2-3L5.666,10H4.3A4.428,4.428,0,0,1,4,8.5,3.5,3.5,0,0,1,7.5,5Z"
      fill="#868e96"
    />
    <rect data-name="Rechteck 3799" width="24" height="24" fill="none" />
  </svg>`;
export const gradeSvg = (classes = 'w-4 h-4') => html ` <svg
    class="${classes}"
    alt="Tecnica"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M2.95 20.91c.42-3.76 1.01-7 7.34-10.16 2.26-1.13 4.05-2.07 1.6-3.76-2.83-1.96 0-5.08 6.68-4.14M15.01 20.9c-1.52-7.14 1.43-6.8 4.69-9.87s-.38-5.08-3.01-5.36"
      style="stroke:#868e96;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;fill:none"
    />
    <path d="M0 0h24v24H0z" style="fill:none" />
  </svg>`;
export const calendarSvg = (classes = 'w-4 h-4') => html ` <svg
    class="${classes}"
    alt="Calendario"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
  <g clip-path="url(#clip0_11_10722)">
<path d="M6 2V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V2H16V4H8V2H6ZM5 6H6H8H16H18H19V8H5V6ZM5 10H19V20H5V10Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_11_10722">
<rect width="24" height="24" fill="white"/>
</clipPath>
  </svg>`;
export const breadcrumbArrowSvg = (classes = 'w-6 h-6') => html ` <svg
    class="${classes}"
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      d="M10,5.93,8.5,7.43,13.07,12,8.5,16.57l1.5,1.5L16.07,12Z"
      clip-rule="evenodd"
    ></path>
  </svg>`;
export const spinnerSvg = (classes = 'w-14 h-14 text-chm-gray fill-chm-red') => html ` <svg
    role="status"
    class="${classes} inline animate-spin"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>`;
export const configSvg = (classes = 'fill-chm-red h-[24px] w-[24px]') => html `<svg
    id="i_settings"
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 24 24"
  >
    <rect
      id="Rechteck_3768"
      data-name="Rechteck 3768"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="Pfad_13084"
      data-name="Pfad 13084"
      d="M9.829,14a4,4,0,1,1,4-4,4,4,0,0,1-4,4m0-6a2,2,0,1,0,2,2,2,2,0,0,0-2-2m2.332,12H7.5l-.492-2.522A7.9,7.9,0,0,1,4.76,16.186l-2.423.837L0,12.982l1.944-1.69a7.367,7.367,0,0,1,0-2.582L0,7.023,2.337,2.977l2.423.837A7.906,7.906,0,0,1,7,2.527L7.5,0H12.16l.492,2.522A7.9,7.9,0,0,1,14.9,3.814l2.423-.837,2.338,4.041-1.944,1.69a7.373,7.373,0,0,1,0,2.583l1.939,1.686-2.331,4.046L14.9,16.186a7.974,7.974,0,0,1-2.243,1.286ZM9.145,18h1.368l.39-2,1.043-.4a5.985,5.985,0,0,0,1.683-.96l.865-.709,1.919.663.685-1.188L15.56,12.068l.18-1.1a5.394,5.394,0,0,0,0-1.938V9.018l-.171-1.1L17.1,6.585,16.416,5.4l-1.921.663-.866-.71a5.927,5.927,0,0,0-1.683-.966L10.9,4l-.391-2H9.145l-.39,2-1.043.4a5.917,5.917,0,0,0-1.683.958l-.867.711-1.92-.663L2.557,6.594,4.1,7.931l-.18,1.1a5.394,5.394,0,0,0,0,1.938v.012l.171,1.1L2.557,13.409,3.243,14.6l1.921-.663.866.71a5.927,5.927,0,0,0,1.683.966L8.754,16Z"
      transform="translate(2 2)"
    />
  </svg>`;
export const chevronSvg = (classes = 'w-3 h-3 shrink-0') => html `<svg
    id="chevron-icon"
    class="${classes}"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
    ></path>
  </svg>`;
export const uploadPictureSvg = (classes = 'h-[24px] w-[24px]', ariaLabel = '') => html ` <svg
    id="i_upload_picture"
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="${ariaLabel}"
  >
    <path
      id="Pfad_13756"
      data-name="Pfad 13756"
      d="M16.03,8.03l-.02,3.1L12.97,9.42l-1.91,1.74L4.98,7.3,2,9.4V5a1,1,0,0,1,.99-1h9.03V2.01H2.98A2.987,2.987,0,0,0,0,4.99V15.98a2.981,2.981,0,0,0,2.98,2.98h12A2.981,2.981,0,0,0,17.95,16L18,8.03H16.03Zm-1.04,8.95H2.98a.994.994,0,0,1-.99-1V11.82L5.03,9.69l6.25,3.97,1.97-1.8,2.74,1.54-.02,2.59a1,1,0,0,1-.99.99ZM20.03,1.97v2h-2V6h-2V3.97H14.04v-2h1.99V0h2V1.97ZM10.06,6.2A1.29,1.29,0,1,1,8.77,7.49,1.291,1.291,0,0,1,10.06,6.2"
      transform="translate(1.985 2.521)"
    />
  </svg>`;
export const uploadFileSvg = (classes = 'h-[24px] w-[24px]', ariaLabel = '') => html `<svg
    class="${classes}"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="${ariaLabel}"
  >
    <g clip-path="url(#clip0_11_10710)">
      <path
        d="M12 2L7 7H11V16H13V7H17L12 2ZM2 9V20C2 21.0931 2.90694 22 4 22H20C21.0931 22 22 21.0931 22 20V9H20V20H4V9H2Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_10710">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>`;
export const successSvg = ({ classes = 'h-[24px] w-[24px]', ariaLabel = '', alt = '', }) => html `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    aria-label="${ariaLabel}"
    alt="${alt}"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="9" fill="#009139" />
    <path
      fill="#fff"
      d="M12 2a10 10 0 1 0 10 10A10.015 10.015 0 0 0 12 2Zm0 2a8 8 0 1 1-8 8 7.985 7.985 0 0 1 8-8Zm4.293 4.293L10 14.586l-2.293-2.293-1.414 1.414L10 17.414l7.707-7.707Z"
    />
  </svg>
`;
export const noInfoSvg = ({ classes = 'h-[24px] w-[24px]', ariaLabel = '', alt = '', }) => html `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    aria-label="${ariaLabel}"
    alt="${alt}"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="9" fill="#868E96" />
    <path
      fill="none"
      stroke="#fff"
      stroke-width="2"
      d="M12 2a10 10 0 1 0 10 10A10.015 10.015 0 0 0 12 2Z"
    />
  </svg>
`;
export const errorSvg = ({ classes = 'h-[24px] w-[24px]', ariaLabel = '', alt = '', }) => html `<svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    aria-label="${ariaLabel}"
    alt="${alt}"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="11" fill="#fff" style="stroke-width:1.22222" />
    <path
      fill="#e30613"
      d="M18.364 5.636a9 9 0 1 0 0 12.728 9 9 0 0 0 0-12.728zm-3.818 10.182L12 13.273l-2.546 2.546-1.27-1.274L10.727 12 8.183 9.455l1.27-1.275L12 10.727l2.546-2.546 1.272 1.274-2.545 2.544 2.545 2.546z"
    />
  </svg> `;
export const crossSvg = (classes = 'h-[24px] w-[24px] fill-chm-red', ariaLabel = '') => html ` <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="${ariaLabel}"
  >
    <path
      d="M4.707,3.293,3.293,4.707,10.586,12,3.293,19.293l1.414,1.414L12,13.414l7.293,7.293,1.414-1.414L13.414,12l7.293-7.293L19.293,3.293,12,10.586Z"
    />
  </svg>`;
export const eyeSvg = (classes = 'h-[24px] w-[24px] fill-chm-red', ariaLabel = '') => html ` <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="${ariaLabel}"
  >
    <path
      d="M12 4C4 4 1 12 1 12C1 12 4 20 12 20C20 20 23 12 23 12C23 12 20 4 12 4ZM12 6C17.276 6 19.9446 10.2671 20.8086 11.9961C19.9436 13.7131 17.255 18 12 18C6.724 18 4.05541 13.7329 3.19141 12.0039C4.05741 10.2869 6.745 6 12 6ZM12 8C9.791 8 8 9.791 8 12C8 14.209 9.791 16 12 16C14.209 16 16 14.209 16 12C16 9.791 14.209 8 12 8ZM12 10C13.105 10 14 10.895 14 12C14 13.105 13.105 14 12 14C10.895 14 10 13.105 10 12C10 10.895 10.895 10 12 10Z"
    />
  </svg>`;
export const strikedEyeSvg = (classes = 'h-[24px] w-[24px] fill-chm-red', ariaLabel = '') => html ` <svg
    class="${classes}"
    viewBox="0 2 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="${ariaLabel}"
  >
    <path
      d="M3.70703 4L2.29297 5.41406L5.06836 8.18945C4.52925 8.62894 4.04856 9.09704 3.61914 9.56641C1.78914 11.6064 1 13.707 1 13.707C1 13.707 4 21.707 12 21.707C13.2 21.707 14.2895 21.5268 15.2695 21.2168C15.9886 20.9971 16.6486 20.7086 17.248 20.3691L20.293 23.4141L21.707 22L3.70703 4ZM12 5.70703C10.8 5.70703 9.71047 5.88727 8.73047 6.19727L10.3906 7.85742C10.8906 7.75742 11.43 7.70703 12 7.70703C17.28 7.70703 19.9405 11.977 20.8105 13.707C20.4805 14.367 19.8709 15.4077 18.9609 16.4277L20.3809 17.8477C22.2109 15.8077 23 13.707 23 13.707C23 13.707 20 5.70703 12 5.70703ZM6.48828 9.60938L8.55859 11.6797C8.19945 12.2792 8 12.968 8 13.707C8 13.787 7.99977 13.877 8.00977 13.957C8.12977 15.967 9.74 17.5773 11.75 17.6973C11.83 17.7073 11.92 17.707 12 17.707C12.7391 17.707 13.4279 17.5076 14.0273 17.1484L15.7578 18.8789C15.1084 19.1884 14.3885 19.4268 13.6094 19.5566C13.0994 19.6566 12.57 19.707 12 19.707C6.72 19.707 4.05945 15.437 3.18945 13.707C3.51945 13.047 4.11906 12.0063 5.03906 10.9863C5.44851 10.517 5.93918 10.0489 6.48828 9.60938ZM12.25 9.7168L15.9902 13.457C15.8702 11.447 14.26 9.8368 12.25 9.7168ZM10.0703 13.1914L12.5156 15.6367C12.3565 15.6859 12.1787 15.707 12 15.707C10.9 15.707 10 14.807 10 13.707C10 13.5284 10.0211 13.3505 10.0703 13.1914Z"
    />
  </svg>`;
export const shareSvg = (classes = 'fill-chm-red', ariaLabel = '') => html ` <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-label="${ariaLabel}"
    class="${classes}"
  >
    <path
      d="M18,2a3.015,3.015,0,0,0-3,3,2.956,2.956,0,0,0,.057.559L7.922,9.721A2.969,2.969,0,0,0,6,9a3,3,0,0,0,0,6,2.969,2.969,0,0,0,1.922-.721l7.135,4.16A2.956,2.956,0,0,0,15,19a3,3,0,1,0,3-3,2.968,2.968,0,0,0-1.922.723L8.943,12.559a2.783,2.783,0,0,0,0-1.117l7.135-4.162A2.969,2.969,0,0,0,18,8a3,3,0,0,0,0-6Zm0,2a1,1,0,1,1-1,1A.985.985,0,0,1,18,4ZM6,11a1,1,0,1,1-1,1A.985.985,0,0,1,6,11Zm12,7a1,1,0,1,1-1,1A.985.985,0,0,1,18,18Z"
    />
  </svg>`;
export const copySvg = (classes = 'fill-chm-red', ariaLabel = '') => html ` <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-label="${ariaLabel}"
    class="${classes}"
  >
    <path
      d="M18,4H6A2,2,0,0,0,4,6V18a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2m0,14H6V6H18ZM2,2H16V0H2A2,2,0,0,0,0,2V16H2Z"
      transform="translate(2 2)"
    />
  </svg>`;
export const emailSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M17.75 3H4.34C3.05 3 2 4.05 2 5.34v9.39c0 1.29 1.05 2.34 2.34 2.34h9.05v-2H4.34c-.19 0-.34-.15-.34-.34V7.88l6.49 4.33c.17.11.36.17.55.17s.39-.06.55-.17l6.49-4.33v6.51h2V5.34c0-1.29-1.05-2.34-2.34-2.34zm-6.7 7.17L4 5.48v-.14c0-.19.15-.34.34-.34h13.41c.19 0 .34.15.34.34v.14l-7.05 4.7zm3.05 9.91h4v3l4-4-4-4v3h-4z"
    />
  </svg>
`;
export const shareOrPrintSvg = (classes = 'w-4 h-4') => html `
  <svg class="${classes}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M11.2,15.771a.816.816,0,1,1,.815-.816.817.817,0,0,1-.815.816M21.044,12.4a2.242,2.242,0,0,1-4.407-.827L11.846,8.777a2.173,2.173,0,0,1-1.341.468,2.2,2.2,0,1,1,0-4.4,2.176,2.176,0,0,1,1.342.473l4.79-2.794a2.373,2.373,0,0,1-.026-.322,2.218,2.218,0,0,1,2.2-2.2h0a2.2,2.2,0,1,1,0,4.4,2.175,2.175,0,0,1-1.341-.468L12.679,6.722a1.977,1.977,0,0,1,0,.648l4.791,2.8A2.242,2.242,0,0,1,21.044,12.4M18.81,11.321h-.02a.556.556,0,0,0-.392.171.55.55,0,0,0-.156.4.569.569,0,1,0,.568-.567m0-8.553a.569.569,0,1,0,0-1.137h-.02a.557.557,0,0,0-.548.567.569.569,0,0,0,.568.571m-8.3,3.708h-.021a.558.558,0,0,0-.548.567.569.569,0,1,0,.569-.567m3.584,7.787v4.969H11.321V22H2.769V19.231H0V14.263a2.211,2.211,0,0,1,2.2-2.2h.569V9.294H6.912v1.631H4.4v1.137h7.489a2.213,2.213,0,0,1,2.2,2.2m-2.769,1.953V17.6h1.137V14.263a.569.569,0,0,0-.57-.569H2.2a.569.569,0,0,0-.57.569V17.6H2.769V16.216ZM9.69,17.847H4.4v2.521H9.69Z"
      transform="translate(1.454 1)">
  </svg>`;
export const plusSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M11 3v8H3v2h8v8h2v-8h8v-2h-8V3Z" />
  </svg>
`;
export const minusSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M3 11v2h18v-2Z" />
  </svg>
`;
export const targetSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke-width="2"
      d="M21.045 2.523a.25.25 0 0 1 .33.33l-8.181 18.25a.5.5 0 0 1-.953-.147l-.969-8.331-8.331-.969a.5.5 0 0 1-.147-.953Z"
    />
  </svg>
`;
export const swissSvg = (classes = 'w-[24px] h-[21px]', fill = '#fff') => html `
  <svg
    class="${classes}"
    viewBox="0 0 50 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.3615 6.243C28.3445 6.134 28.3335 6.022 28.3115 5.913C28.2955 5.834 28.2705 5.759 28.2515 5.681C28.2135 5.521 28.1775 5.36 28.1285 5.204C28.0675 5.008 27.9945 4.817 27.9175 4.628C27.9035 4.594 27.8935 4.558 27.8795 4.524C27.8165 4.375 27.7425 4.233 27.6695 4.089C27.6345 4.019 27.6045 3.945 27.5675 3.876C27.5035 3.759 27.4305 3.649 27.3605 3.536C27.3055 3.446 27.2545 3.353 27.1965 3.266C27.1265 3.162 27.0465 3.066 26.9715 2.966C26.9045 2.876 26.8415 2.782 26.7695 2.696C26.7105 2.624 26.6435 2.558 26.5815 2.489C26.4855 2.381 26.3925 2.271 26.2915 2.169C26.2365 2.115 26.1755 2.066 26.1185 2.013C26.0025 1.904 25.8885 1.793 25.7655 1.692C25.6815 1.622 25.5905 1.561 25.5035 1.495C25.4005 1.418 25.3015 1.337 25.1955 1.265C25.1035 1.203 25.0055 1.151 24.9105 1.093C24.8025 1.026 24.6965 0.955 24.5845 0.894C24.4795 0.837 24.3685 0.79 24.2605 0.738C24.1525 0.686 24.0475 0.629 23.9375 0.583C23.8045 0.526 23.6665 0.482 23.5295 0.433C23.4385 0.401 23.3505 0.362 23.2575 0.334C23.1365 0.296 23.0115 0.27 22.8885 0.239C22.7745 0.209 22.6625 0.175 22.5465 0.151C22.4195 0.125 22.2885 0.111 22.1585 0.091C22.0435 0.074 21.9295 0.051 21.8125 0.039C21.6775 0.025 21.5385 0.024 21.4015 0.018C21.2845 0.012 21.1705 0 21.0525 0C16.9655 0.004 13.6535 3.319 13.6525 7.406C13.6525 11.6 18.3105 17.793 20.2335 20.18C20.3025 20.265 20.3905 20.322 20.4775 20.379C20.5365 20.418 20.5975 20.451 20.6615 20.477C20.7245 20.502 20.7885 20.522 20.8555 20.535C20.9205 20.547 20.9865 20.554 21.0535 20.554C21.1205 20.554 21.1875 20.547 21.2545 20.535C21.3195 20.522 21.3825 20.503 21.4445 20.478C21.5105 20.452 21.5725 20.418 21.6325 20.378C21.7195 20.321 21.8065 20.264 21.8755 20.18C23.7985 17.793 28.4625 11.6 28.4625 7.406C28.4625 7.009 28.4225 6.623 28.3615 6.243ZM21.0525 10.051C19.5915 10.051 18.4075 8.867 18.4075 7.406C18.4075 6.675 18.7035 6.014 19.1825 5.535C19.6615 5.056 20.3225 4.76 21.0535 4.76C22.5145 4.76 23.6985 5.944 23.6985 7.405C23.6985 8.136 23.4025 8.797 22.9235 9.276C22.4445 9.755 21.7835 10.051 21.0525 10.051ZM49.0425 16.93V31.036H40.3315L35.2995 43.617L29.2575 33.545L26.2415 41.118H13.1415L11.2175 31.497L0.95752 34.056L11.9035 12.157C12.4995 13.637 13.3005 15.136 14.1985 16.586L8.48552 28.017L14.3455 26.552L16.4455 37.083H23.4975L28.5365 24.503L34.5795 34.577L37.5995 27.011H45.0155V20.966H37.3975L35.3785 12.904H29.8975C30.5105 11.532 30.9545 10.171 31.1585 8.872H38.5305L40.5425 16.93H49.0425Z"
      fill="${fill}"
    />
  </svg>
`;
export const openMapActionSvg = (classes = 'w-[4px] h-[18px]', fill = '#fff') => html `
  <svg
    class="${classes}"
    viewBox="0 0 4 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 0C2.39556 0 2.78224 0.117298 3.11114 0.337061C3.44004 0.556824 3.69638 0.869181 3.84776 1.23463C3.99913 1.60009 4.03874 2.00222 3.96157 2.39018C3.8844 2.77814 3.69392 3.13451 3.41421 3.41421C3.13451 3.69392 2.77814 3.8844 2.39018 3.96157C2.00222 4.03874 1.60009 3.99913 1.23463 3.84776C0.869181 3.69638 0.556824 3.44004 0.337061 3.11114C0.117298 2.78224 0 2.39556 0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0ZM2 7C2.39556 7 2.78224 7.1173 3.11114 7.33706C3.44004 7.55682 3.69638 7.86918 3.84776 8.23463C3.99913 8.60009 4.03874 9.00222 3.96157 9.39018C3.8844 9.77814 3.69392 10.1345 3.41421 10.4142C3.13451 10.6939 2.77814 10.8844 2.39018 10.9616C2.00222 11.0387 1.60009 10.9991 1.23463 10.8478C0.869181 10.6964 0.556824 10.44 0.337061 10.1111C0.117298 9.78224 0 9.39556 0 9C0 8.46957 0.210714 7.96086 0.585786 7.58579C0.960859 7.21071 1.46957 7 2 7ZM2 14C2.39556 14 2.78224 14.1173 3.11114 14.3371C3.44004 14.5568 3.69638 14.8692 3.84776 15.2346C3.99913 15.6001 4.03874 16.0022 3.96157 16.3902C3.8844 16.7781 3.69392 17.1345 3.41421 17.4142C3.13451 17.6939 2.77814 17.8844 2.39018 17.9616C2.00222 18.0387 1.60009 17.9991 1.23463 17.8478C0.869181 17.6964 0.556824 17.44 0.337061 17.1111C0.117298 16.7822 0 16.3956 0 16C0 15.4696 0.210714 14.9609 0.585786 14.5858C0.960859 14.2107 1.46957 14 2 14Z"
      fill="${fill}"
    />
  </svg>
`;
export const tourListSortSvg = (classes = 'w-4 h-4', fill = '#fff') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
  >
    <path
      fill="${fill}"
      d="m 24,6 a 4,4 0 1 1 -4,4 4,4 0 0 1 4,-4 m 0,14 a 4,4 0 1 1 -4,4 4,4 0 0 1 4,-4 m 0,14 a 4,4 0 1 1 -4,4 4,4 0 0 1 4,-4"
    />
  </svg>
`;
export const linkSvg = (classes = '', ariaLabel = '') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="-4 -4 24 24"
    aria-label="${ariaLabel}"
  >
    <path
      d="M10.0128 0L8.80399 1.20884L9.73913 2.14398L4.43621 6.39772L3.17035 5.13186L1.96151 6.3407L5.21169 9.59088L0 14.8026V16H1.19743L6.40912 10.7883L9.6593 14.0385L10.8681 12.8297L9.6707 11.6322L13.8674 6.27227L14.7912 7.19601L16 5.98717L10.0128 0ZM10.948 3.37562L12.6472 5.07484L8.53029 10.3321L5.74768 7.54954L10.9366 3.37562H10.948Z"
    />
  </svg>
`;
export const closeMapActionSvg = (classes = 'h-[18px]', fill = '#fff') => html `
  <svg
    class="${classes}"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.46164 0L0 1.46164L7.53836 9L0 16.5384L1.46164 18L9 10.4616L16.5384 18L18 16.5384L10.4616 9L18 1.46164L16.5384 0L9 7.53836L1.46164 0Z"
      fill="${fill}"
    />
  </svg>
`;
export const sharePrintSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M19 21.707H5a3 3 0 0 1-3-3v-11h2v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2h2v2a3 3 0 0 1-3 3M16.707 2l-1.414 1.414 2.293 2.293H17a11 11 0 0 0-11 11v1h2v-1a9.011 9.011 0 0 1 9-9h.586L15.293 10l1.414 1.414 4.707-4.707Z"
    />
  </svg>
`;
export const layersSvg = (classes = 'w-[28px]', fill = '#fff') => html `
  <svg
    class="${classes}"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 14 0 L 0 7.083 L 2.451 8.319 L 6.841 10.542 L 0 14.001 L 6.841 17.459 L 0 20.917 L 14 28 L 28 20.917 L 21.159 17.459 L 28 14.001 L 21.159 10.542 L 28 7.083 L 14 0 Z M 14 3.095 L 21.887 7.083 L 14.01 11.071 L 6.123 7.083 L 14 3.095 Z M 9.897 12.089 L 14 14.166 L 18.103 12.089 L 21.887 14.001 L 14.01 17.988 L 6.123 14.001 L 9.897 12.089 Z M 9.897 19.017 L 14 21.093 L 18.103 19.017 L 21.887 20.928 L 14.01 24.916 L 6.123 20.928 L 9.897 19.017 Z"
      fill="${fill}"
    />
  </svg>
`;
export const layersSelectedSvg = (classes = 'w-[28px]', fill = '#fff') => html `
  <svg
    class="${classes}"
    viewBox="0 0 28 34"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 14 34 L 0 27.034 L 14 34 Z M 27.959 3.574 C 27.959 5.546 26.349 7.149 24.369 7.149 C 22.39 7.149 20.779 5.546 20.779 3.574 C 20.779 1.603 22.39 0 24.369 0 C 26.349 0 27.959 1.603 27.959 3.574 Z"
      fill="${fill}"
    />
    <path
      d="M 13.968 6 L -0.031 13.083 L 2.419 14.319 L 6.808 16.542 L -0.031 20.001 L 6.808 23.459 L -0.031 26.917 L 13.968 34 L 27.969 26.917 L 21.128 23.459 L 27.969 20.001 L 21.128 16.542 L 27.969 13.083 L 13.968 6 Z M 13.968 9.095 L 21.856 13.083 L 13.979 17.071 L 6.091 13.083 L 13.968 9.095 Z M 9.866 18.089 L 13.968 20.166 L 18.072 18.089 L 21.856 20.001 L 13.979 23.988 L 6.091 20.001 L 9.866 18.089 Z M 9.866 25.017 L 13.968 27.093 L 18.072 25.017 L 21.856 26.928 L 13.979 30.916 L 6.091 26.928 L 9.866 25.017 Z"
      fill="${fill}"
    />
  </svg>
`;
export function resetSvg() {
    return html `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <rect width="24" height="24" fill="none" />
      <path
        d="M12,2A10,10,0,1,0,22,12H20a8.022,8.022,0,1,1-2.35-5.65L15,9h7V2L19.061,4.939A9.944,9.944,0,0,0,12,2Z"
        fill="#ad091d"
      />
    </svg>
  `;
}
export function phoneSvg(classes = 'w-4 h-4') {
    return html `
    <svg
      class="${classes}"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M20,3A16.955,16.955,0,0,0,3,20a.992.992,0,0,0,1,1H7.51a1,1,0,0,0,1-.977,15.077,15.077,0,0,1,.14-1.924,14.67,14.67,0,0,1,.425-1.653,1.017,1.017,0,0,0-.253-1.019L6.62,13.21a15.618,15.618,0,0,1,6.59-6.59l2.218,2.2a1.018,1.018,0,0,0,1.019.253A14.83,14.83,0,0,1,18.1,8.652a15.063,15.063,0,0,1,1.924-.14,1,1,0,0,0,.976-1V4A.992.992,0,0,0,20,3ZM7,16.426c-.142.5-.247.946-.314,1.326A11.139,11.139,0,0,0,6.552,19H5.034a15.066,15.066,0,0,1,.758-3.785ZM19,6.552a11.113,11.113,0,0,0-1.248.131c-.38.067-.824.172-1.326.314l-1.211-1.2A15.076,15.076,0,0,1,19,5.034Z"
      />
      <rect width="24" height="24" fill="none" />
    </svg>
  `;
}
export function downloadSvg(classes = 'fill-chm-red', stroke = '') {
    return html `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      class="${classes}"
    >
      <rect width="24" height="24" fill="none" />
      <path
        class="${stroke}"
        d="M6,2A2.013,2.013,0,0,0,4,4V20a2.013,2.013,0,0,0,2,2H16.172l-1.586-1.586L14.172,20H6V4h7V9h5v3h2V8L14,2ZM18,14v4H15l4,4,4-4H20V14Z"
        transform="translate(-1)"
      />
    </svg>
  `;
}
export function navFirstSvg(fill = 'fill-chm-red', stroke = 'stroke-chm-red') {
    return html `
    <svg
      class="mx-auto my-[8px] lg:my-[16px]"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M26.273 24h-24V0h24z" />
      <path
        class="${fill}"
        fill="none"
        d="m12.273 19 1.5-1.5-4.57-4.57h14.07v-2H9.203l4.57-4.571-1.5-1.5-7.07 7.07z"
      />
      <path
        class="${stroke}"
        fill="none"
        stroke="none"
        stroke-width="2"
        d="M1.737 3v18"
      />
    </svg>
  `;
}
export function navNextSvg(fill = 'fill-chm-red') {
    return html `
    <svg
      class="mx-auto my-[8px] lg:my-[16px]"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      alt=""
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        class="${fill}"
        fill="none"
        d="m14 5-1.5 1.5 4.57 4.57H3v2h14.07l-4.57 4.57 1.5 1.5 7.07-7.07Z"
      />
    </svg>
  `;
}
export function navPreviousSvg(fill = 'fill-chm-red') {
    return html `
    <svg
      class="mx-auto my-[8px] lg:my-[16px]"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      alt=""
      height="24"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M24 24H0V0h24z" />
      <path
        class="${fill}"
        fill="none"
        d="m10 19 1.5-1.5-4.57-4.57H21v-2H6.93l4.57-4.57-1.5-1.5-7.07 7.07Z"
      />
    </svg>
  `;
}
export function image0(src) {
    if (!src)
        return '';
    return src.replace('webdb0-bucket-1qo88wr12euqw.s3.amazonaws.com', 'images.schweizmobil.ch');
}
export function getPhoto(data) {
    let photo = data.photoBig || data.photo || data.photoSmall;
    if (photo)
        photo = image0(photo);
    return photo;
}
export function getPhotoAbstract(data) {
    const photoAbstract = data.photoAbstract;
    return photoAbstract;
}
export function divider(width, height, padding, color, classes) {
    return html ` <div
    class=${ifDefined(classes)}
    style="${styleMap({ padding: padding })}"
  >
    <div style="${styleMap({ backgroundColor: color, height, width })}"></div>
  </div>`;
}
export function closeHeader(title, close, scrolled) {
    return html ` <div
    class="group ${classMap({
        'shadow-popup': scrolled,
    })} sticky top-0 flex h-[40px] items-center justify-between bg-white py-[8px] pl-[16px] pr-[8px]"
  >
    <span
      data-cy="poi-header-title"
      class="body-links-and-text overflow-hidden text-ellipsis whitespace-nowrap"
      >${title}</span
    >
    <div class="cursor-pointer" @click="${close}">
      ${crossSvg('clickable-icon-in-group')}
    </div>
  </div>`;
}
export function overlayHeader(options) {
    const closeText = options?.closeText !== undefined ? options.closeText : true;
    const classFont = options?.classFont !== undefined
        ? options.classFont
        : 'text-overlay-header md:text-md-overlay-header lg:text-lg-overlay-header';
    return html ` <div
    class="${classMap({
        flex: !options?.maxScreenSizeCode || !!options?.maxScreenSizeCode,
        [`${options?.maxScreenSizeCode}:hidden`]: !!options?.maxScreenSizeCode,
        'shadow-popup': options?.scrolled,
    })} items-start sticky top-0 z-50 bg-inherit px-[20px] pb-[12px] pt-[20px] gap-x-[20px]"
  >
    <div class="${classFont} flex flex-1">${options?.title || ''}</div>
    <button
      data-cy="close"
      class="group ${classFont} sticky top-0 flex cursor-pointer items-center clickable-icon-with-text"
      @click="${(event) => {
        event.stopPropagation();
        if (options?.onClose) {
            options.onClose();
        }
        modal$.next(undefined);
    }}"
    >
      ${closeText ? `Chiudere` : ''} ${crossSvg('clickable-icon-in-group')}
    </button>
  </div>`;
}
export function arrivalLinks(stationName, card = true) {
    const arrivalUrl = `${SBB_URL_BY_LANG[getLanguageCode()]}?nach=${stationName}`;
    const returnUrl = `${SBB_URL_BY_LANG[getLanguageCode()]}?von=${stationName}`;
    return html ` <div
      data-cy="station-arrival-url"
      class="${classMap({
        'link-with-icon-in-context': card,
        'link-with-icon-alone': !card,
    })}"
    >
      <a
        href="${arrivalUrl}"
        target="_blank"
        class="group flex items-center overflow-hidden clickable-icon-with-text"
      >
        <span class="group"
          >${externalLinkSvg({
        classes: 'clickable-icon-in-group',
    })}</span
        >
        <span>Andata</span>
        <span class="screen-reader-only">si apre in una nuova scheda</span>
      </a>
    </div>
    <div
      data-cy="station-return-url"
      class="${classMap({
        'link-with-icon-in-context': card,
        'link-with-icon-alone': !card,
    })}"
    >
      <a
        href="${returnUrl}"
        target="_blank"
        class="group flex items-center overflow-hidden clickable-icon-with-text"
      >
        <span
          >${externalLinkSvg({
        classes: 'clickable-icon-in-group',
    })}</span
        >
        <span>Ritorno</span>
        <span class="screen-reader-only">si apre in una nuova scheda</span>
      </a>
    </div>`;
}
export const instagramSvg = (classes = 'w-4 h-4', ariaLabel = '') => html `
  <svg
    class="${classes}"
    role="img"
    alt="Instagram"
    aria-labelledby="instagramTitle"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="${ariaLabel}"
  >
    <title id="instagramTitle">Instagram</title>
    <rect
      id="Rechteck_4160"
      data-name="Rechteck 4160"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="icons8-instagram"
      d="M8,3A5.006,5.006,0,0,0,3,8v8a5.006,5.006,0,0,0,5,5h8a5.006,5.006,0,0,0,5-5V8a5.006,5.006,0,0,0-5-5ZM8,5h8a3,3,0,0,1,3,3v8a3,3,0,0,1-3,3H8a3,3,0,0,1-3-3V8A3,3,0,0,1,8,5Zm9,1a1,1,0,1,0,1,1A1,1,0,0,0,17,6ZM12,7a5,5,0,1,0,5,5A5.006,5.006,0,0,0,12,7Zm0,2a3,3,0,1,1-3,3A3,3,0,0,1,12,9Z"
    />
  </svg>
`;
export const facebookSvg = (classes = 'w-4 h-4', ariaLabel = '') => html `
  <svg
    class="${classes}"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    alt="Facebook"
    aria-label="${ariaLabel}"
  >
    <title>Facebook</title>
    <path
      d="M12 3C7.03832 3 3 7.03832 3 12C3 16.9617 7.03832 21 12 21C16.9617 21 21 16.9617 21 12C21 7.03832 16.9617 3 12 3ZM12 4.5C16.151 4.5 19.5 7.84898 19.5 12C19.5 15.7705 16.7338 18.871 13.1162 19.4092V14.187H15.252L15.5874 12.0176H13.1162V10.8325C13.1162 9.93177 13.4121 9.13184 14.2544 9.13184H15.6079V7.23926C15.3702 7.20701 14.867 7.13672 13.916 7.13672C11.93 7.13672 10.7666 8.18521 10.7666 10.5747V12.0176H8.72461V14.187H10.7666V19.3901C7.20664 18.803 4.5 15.7298 4.5 12C4.5 7.84898 7.84898 4.5 12 4.5Z"
    />
  </svg>
`;
export const linkedInSvg = (classes = 'w-4 h-4', ariaLabel = '') => html `
  <svg
    class="${classes}"
    role="img"
    alt="Linkedin"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="${ariaLabel}"
  >
    <title>LinkedIn</title>
    <rect
      id="Rechteck_4161"
      data-name="Rechteck 4161"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="icons8-linkedin"
      d="M5,3A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2ZM5,5H19V19H5ZM7.779,6.316a1.223,1.223,0,0,0-1.371,1.2,1.194,1.194,0,0,0,1.285,1.2,1.222,1.222,0,0,0,1.371-1.2A1.2,1.2,0,0,0,7.779,6.316ZM6.477,10v7H9V10Zm4.605,0v7h2.523V13.174c0-1.139.813-1.3,1.057-1.3s.9.245.9,1.3V17H18V13.174c0-2.2-.976-3.174-2.2-3.174a2.282,2.282,0,0,0-2.2.977V10Z"
    />
  </svg>
`;
export const youtubeSvg = (classes = 'w-4 h-4', ariaLabel = '') => html `
  <svg
    class="${classes}"
    role="img"
    alt="Youtube"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="${ariaLabel}"
  >
    <title>YouTube</title>
    <rect
      id="Rechteck_4162"
      data-name="Rechteck 4162"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="icons8-youtube"
      d="M12,4s-6.254,0-7.814.418A2.5,2.5,0,0,0,2.418,6.186,35.647,35.647,0,0,0,2,12a35.647,35.647,0,0,0,.418,5.814,2.5,2.5,0,0,0,1.768,1.768C5.746,20,12,20,12,20s6.254,0,7.814-.418a2.5,2.5,0,0,0,1.768-1.768A35.647,35.647,0,0,0,22,12a35.647,35.647,0,0,0-.418-5.814,2.5,2.5,0,0,0-1.768-1.768C18.254,4,12,4,12,4Zm0,2a53.985,53.985,0,0,1,7.3.35.508.508,0,0,1,.354.354A32.03,32.03,0,0,1,20,12a32.039,32.039,0,0,1-.35,5.3.508.508,0,0,1-.354.354A53.975,53.975,0,0,1,12,18a54.007,54.007,0,0,1-7.3-.35A.508.508,0,0,1,4.35,17.3,32.031,32.031,0,0,1,4,12a32.073,32.073,0,0,1,.35-5.3A.505.505,0,0,1,4.7,6.35,53.975,53.975,0,0,1,12,6ZM10,8.535v6.93L16,12Z"
    />
  </svg>
`;
export const goToFooterSvg = (classes = 'w-4 h-4') => html `
  <svg
    class="${classes}"
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m 17.425,20.1435 -1.425,1.413 10.208,10.3 9.792,-10.313 -1.454,-1.385 -8.369,8.815 z"
    />
  </svg>
`;
export const showOnMapSvg = (classes = 'w-4 h-4') => html `
  <svg
    viewBox="0 0 24 24"
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    alt="Show on map"
  >
    <path
      d="M17.211 2.02295C16.2062 2.02321 15.2426 2.4225 14.5321 3.13301C13.8216 3.84353 13.4223 4.80713 13.422 5.81195C13.422 8.52095 17.211 12.4439 17.211 12.4439C17.211 12.4439 21 8.52295 21 5.81195C20.9997 4.80713 20.6005 3.84353 19.8899 3.13301C19.1794 2.4225 18.2158 2.02321 17.211 2.02295ZM17.211 4.46095C17.4781 4.46273 17.7386 4.54355 17.9598 4.69323C18.1809 4.84292 18.3528 5.05474 18.4538 5.302C18.5547 5.54925 18.5801 5.82086 18.5269 6.08255C18.4736 6.34425 18.344 6.5843 18.1545 6.77245C17.965 6.96059 17.7239 7.08838 17.4619 7.13971C17.1998 7.19104 16.9284 7.1636 16.6819 7.06086C16.4354 6.95812 16.2248 6.78468 16.0768 6.56241C15.9287 6.34014 15.8498 6.07901 15.85 5.81195C15.8519 5.45248 15.9962 5.10841 16.2513 4.85516C16.5064 4.60191 16.8515 4.46015 17.211 4.46095ZM8.65001 4.80595L3.59701 6.82895C3.42028 6.89796 3.26848 7.01867 3.16144 7.1753C3.0544 7.33194 2.99709 7.51723 2.99701 7.70695V20.9699C2.9968 21.125 3.03459 21.2778 3.10707 21.4148C3.17955 21.5519 3.28452 21.6692 3.41279 21.7563C3.54106 21.8434 3.68873 21.8978 3.84287 21.9146C3.99702 21.9315 4.15294 21.9103 4.29701 21.8529L8.71301 20.0819L14.397 21.9769L19.455 19.959C19.6316 19.8882 19.783 19.7664 19.8899 19.6091C19.9968 19.4518 20.0543 19.2661 20.055 19.0759V12.0539C19.399 12.8829 18.821 13.5099 18.575 13.7609L18.161 14.1899V18.4329L15.319 19.5729V13.1829C14.6311 12.4174 13.9979 11.6044 13.424 10.7499V19.6559L9.63201 18.3949V7.12295L11.932 7.89295C11.6826 7.22636 11.5474 6.5225 11.532 5.81095C11.532 5.79595 11.532 5.77595 11.532 5.76195L8.65001 4.80595ZM7.73701 7.21395V18.4339L4.89501 19.5739V8.34895L7.73701 7.21395Z"
    />
  </svg>
`;
export const rank1Svg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#161615"
      d="M11.813 0 9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank2Svg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 49 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#161615"
      d="m36.813 0-2.646 8.9H25l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L49 8.9h-9.461zm-25 0L9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank3Svg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 74 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#161615"
      d="m61.813 0-2.646 8.9H50l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L74 8.9h-9.461zm-25 0-2.646 8.9H25l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L49 8.9h-9.461zm-25 0L9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank4Svg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 99 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#161615"
      d="m86.813 0-2.646 8.9H75l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L99 8.9h-9.461zm-25 0-2.646 8.9H50l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L74 8.9h-9.461zm-25 0-2.646 8.9H25l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L49 8.9h-9.461zm-25 0L9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank5Svg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 124 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#161615"
      d="m111.813 0-2.646 8.9H100l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L124 8.9h-9.461zm-25 0-2.646 8.9H75l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L99 8.9h-9.461zm-25 0-2.646 8.9H50l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L74 8.9h-9.461zm-25 0-2.646 8.9H25l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L49 8.9h-9.461zm-25 0L9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank1superiorSvg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 30 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h30v24H0z" data-name="Rechteck 4818" />
    <path
      fill="#161615"
      d="m16.115 13.951 3.368 9.087-7.671-5.853L4.2 23.038l3.26-8.9L0 8.9h9.167L11.812 0l2.727 8.9H24Zm8.975-9.5L23.118.1l-2.485 4.375-4.7-3.646 2.188 6.617a10.647 10.647 0 0 1 9.4 0S29.844.991 29.844.747z"
      data-name="Pfad 13796"
    />
  </svg>
`;
export const rank2superiorSvg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 55 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M25 0h30v24H25z" data-name="Rechteck 4818" />
    <path
      fill="#161615"
      d="m41.115 13.951 3.368 9.087-7.671-5.853-7.612 5.853 3.26-8.9L25 8.9h9.167L36.812 0l2.727 8.9H49Zm8.975-9.5L48.118.1l-2.485 4.375-4.7-3.646 2.188 6.617a10.647 10.647 0 0 1 9.4 0S54.844.991 54.844.747z"
      data-name="Pfad 13796"
    />
    <path
      fill="#161615"
      d="M11.813 0 9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank3superiorSvg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 80 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M50 0h30v24H50z" data-name="Rechteck 4818" />
    <path
      fill="#161615"
      d="m66.115 13.951 3.368 9.087-7.671-5.853-7.612 5.853 3.26-8.9L50 8.9h9.167L61.812 0l2.727 8.9H74Zm8.975-9.5L73.118.1l-2.485 4.375-4.7-3.646 2.188 6.617a10.647 10.647 0 0 1 9.4 0S79.844.991 79.844.747z"
      data-name="Pfad 13796"
    />
    <path
      fill="#161615"
      d="m36.813 0-2.646 8.9H25l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L49 8.9h-9.461zm-25 0L9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank4superiorSvg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 105 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M75 0h30v24H75z" data-name="Rechteck 4818" />
    <path
      fill="#161615"
      d="m91.115 13.951 3.368 9.087-7.671-5.853-7.612 5.853 3.26-8.9L75 8.9h9.167L86.812 0l2.727 8.9H99Zm8.975-9.5L98.118.1l-2.485 4.375-4.7-3.646 2.188 6.617a10.647 10.647 0 0 1 9.4 0s2.323-6.455 2.323-6.699z"
      data-name="Pfad 13796"
    />
    <path
      fill="#161615"
      d="m61.813 0-2.646 8.9H50l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L74 8.9h-9.461zm-25 0-2.646 8.9H25l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L49 8.9h-9.461zm-25 0L9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const rank5superiorSvg = (classes = 'h-4') => html `
  <svg
    class="${classes} w-auto"
    viewBox="0 0 130 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M100 0h30v24h-30z" data-name="Rechteck 4818" />
    <path
      fill="#161615"
      d="m116.115 13.951 3.368 9.087-7.671-5.853-7.612 5.853 3.26-8.9L100 8.9h9.167l2.645-8.9 2.727 8.9H124Zm8.975-9.5L123.118.1l-2.485 4.375-4.7-3.646 2.188 6.617a10.647 10.647 0 0 1 9.4 0s2.323-6.455 2.323-6.699z"
      data-name="Pfad 13796"
    />
    <path
      fill="#161615"
      d="m86.813 0-2.646 8.9H75l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L99 8.9h-9.461zm-25 0-2.646 8.9H50l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L74 8.9h-9.461zm-25 0-2.646 8.9H25l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L49 8.9h-9.461zm-25 0L9.167 8.9H0l7.457 5.238-3.257 8.9 7.617-5.853 7.67 5.853-3.367-9.087L24 8.9h-9.461z"
      data-name="Pfad 13795"
    />
  </svg>
`;
export const zoomInSvg = () => html ` <svg
    xmlns="http://www.w3.org/2000/svg"
    id="i_zoom_in"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      class="fill-chm-red"
      d="M7.1,1.5a5.6,5.6,0,1,0,3.658,9.825l.342.342V12.7l4.8,4.8,1.6-1.6-4.8-4.8H11.667l-.342-.342A5.588,5.588,0,0,0,7.1,1.5Zm0,1.6a4,4,0,1,1-4,4A3.99,3.99,0,0,1,7.1,3.1ZM6.3,4.7V6.3H4.7V7.9H6.3V9.5H7.9V7.9H9.5V6.3H7.9V4.7Zm0,0"
      transform="translate(2.5 2.5)"
    />
  </svg>`;
export const exportGpxSvg = (classes = 'fill-chm-red') => html `<svg
    class="${classes}"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 22H4.92001C3.27001 22 1.92001 20.64 1.92001 18.98V11.02C1.92001 9.35 3.27001 8 4.92001 8H6.02001V10H4.92001C4.37001 10 3.92001 10.46 3.92001 11.02V18.98C3.92001 19.54 4.37001 20 4.92001 20H19C19.55 20 20 19.54 20 18.98V11.02C20 10.46 19.55 10 19 10H17.98V8H19C20.65 8 22 9.35 22 11.02V18.98C22 20.65 20.65 22 19 22ZM7.47001 12.73C6.89001 12.73 6.46001 12.92 6.11001 13.27C5.60001 13.78 5.59001 14.35 5.59001 15.32C5.59001 16.29 5.59001 16.87 6.11001 17.37C6.46001 17.71 6.89001 17.91 7.47001 17.91C8.01001 17.91 8.50001 17.75 8.91001 17.33C9.27001 16.95 9.40001 16.51 9.40001 15.78V15.04H7.48001V15.88H8.42001V16.07C8.42001 16.33 8.36001 16.56 8.19001 16.75C8.03001 16.93 7.79001 17.04 7.48001 17.04C7.21001 17.04 6.99001 16.94 6.85001 16.77C6.66001 16.56 6.60001 16.31 6.60001 15.33C6.60001 14.35 6.66001 14.11 6.85001 13.9C6.99001 13.74 7.21001 13.63 7.48001 13.63C7.99001 13.63 8.28001 13.89 8.40001 14.37H9.40001C9.27001 13.51 8.67001 12.74 7.48001 12.74L7.47001 12.73ZM14.07 14.36C14.07 15.23 13.45 15.95 12.39 15.95H11.41V17.87H10.41V12.77H12.39C13.45 12.77 14.07 13.49 14.07 14.36ZM13.08 14.36C13.08 13.94 12.79 13.66 12.34 13.66H11.41V15.06H12.34C12.79 15.06 13.08 14.77 13.08 14.36ZM18.38 12.77H17.24L16.36 14.42L15.47 12.77H14.33L15.81 15.25L14.23 17.86H15.37L16.36 16.08L17.34 17.86H18.48L16.9 15.25L18.38 12.77ZM16.61 5.79L12.02 1.55L7.45001 5.79L8.81001 7.26L11.01 5.22V11.03H13.01V5.19L15.24 7.26L16.6 5.79H16.61Z"
    />
  </svg>`;
export const importGpxSvg = (classes = 'fill-chm-red') => html ` <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      d="M16.98,20H2.99A3.011,3.011,0,0,1,0,16.98V9.02A3,3,0,0,1,2.99,6H4.08V8.01H2.99A1.012,1.012,0,0,0,2,9.03v7.96a1,1,0,0,0,.99,1.02H16.98a1,1,0,0,0,.98-1.02V9.03a1,1,0,0,0-.98-1.02H15.97V6h1.01a3.011,3.011,0,0,1,2.99,3.02v7.96A3,3,0,0,1,16.98,20M5.58,10.8a1.814,1.814,0,0,0-1.36.54c-.51.51-.52,1.08-.52,2.05s0,1.55.52,2.05a1.852,1.852,0,0,0,1.36.54,1.915,1.915,0,0,0,1.44-.58,2.028,2.028,0,0,0,.49-1.55v-.74H5.59v.84h.94v.19a.97.97,0,0,1-.23.68.916.916,0,0,1-.71.29.791.791,0,0,1-.63-.27c-.19-.21-.25-.46-.25-1.44s.06-1.22.25-1.43a.824.824,0,0,1,.63-.27.867.867,0,0,1,.92.74h1a1.821,1.821,0,0,0-1.92-1.63Zm6.6,1.63a1.563,1.563,0,0,1-1.68,1.59H9.52v1.92h-1v-5.1H10.5a1.563,1.563,0,0,1,1.68,1.59m-.99,0a.678.678,0,0,0-.74-.7H9.52v1.4h.93a.683.683,0,0,0,.74-.7m5.3-1.59H15.35l-.88,1.65-.89-1.65H12.44l1.48,2.48-1.58,2.61h1.14l.99-1.78.98,1.78h1.14l-1.58-2.61ZM13.17,3.32l-2.2,2.04V0H8.98V5.38L6.74,3.31,5.38,4.78,9.96,9.03l4.58-4.25L13.18,3.31Z"
      transform="translate(2 2)"
    />
  </svg>`;
export const createTourSvg = (classes = 'fill-chm-red') => html ` <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      d="M18.5,20.886l-.848-1.356C17.209,18.821,15,15.2,15,13.5a3.5,3.5,0,1,1,7,0c0,1.7-2.209,5.321-2.652,6.03ZM18.5,12A1.5,1.5,0,0,0,17,13.5a11.844,11.844,0,0,0,1.5,3.527A11.865,11.865,0,0,0,20,13.5,1.5,1.5,0,0,0,18.5,12M13,15H11V13h2ZM9,15H7V13H9ZM5,15H3V13H5ZM3.5,10.887,2.652,9.53C2.209,8.821,0,5.2,0,3.5a3.5,3.5,0,0,1,7,0C7,5.2,4.791,8.821,4.348,9.53ZM3.5,2A1.5,1.5,0,0,0,2,3.5,11.854,11.854,0,0,0,3.5,7.027,11.854,11.854,0,0,0,5,3.5,1.5,1.5,0,0,0,3.5,2"
      transform="translate(1 1.999)"
    />
  </svg>`;
export const editTourSvg = (classes = 'fill-chm-red') => html `<svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M17.914.5a.993.993 0 0 0-.707.293L2.5 15.5v4h4L21.207 4.793a1 1 0 0 0 0-1.414L18.621.793A.993.993 0 0 0 17.914.5Zm0 2.414 1.172 1.172-1.293 1.293-1.172-1.172Zm-2.707 2.707 1.172 1.172L5.672 17.5H4.5v-1.172Zm0 0"
    />
    <path d="M3 21h15v2H3z" />
  </svg>`;
export const copyTourSvg = (classes = 'fill-chm-red') => html `<svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      d="M18,4H6A2,2,0,0,0,4,6V18a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2m0,14H6V6H18ZM2,2H16V0H2A2,2,0,0,0,0,2V16H2Z"
      transform="translate(2 2)"
    />
  </svg>`;
export const shareTourSvg = (classes = 'fill-chm-red') => html `<svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      d="M11.2,15.771a.816.816,0,1,1,.815-.816.817.817,0,0,1-.815.816M21.044,12.4a2.242,2.242,0,0,1-4.407-.827L11.846,8.777a2.173,2.173,0,0,1-1.341.468,2.2,2.2,0,1,1,0-4.4,2.176,2.176,0,0,1,1.342.473l4.79-2.794a2.373,2.373,0,0,1-.026-.322,2.218,2.218,0,0,1,2.2-2.2h0a2.2,2.2,0,1,1,0,4.4,2.175,2.175,0,0,1-1.341-.468L12.679,6.722a1.977,1.977,0,0,1,0,.648l4.791,2.8A2.242,2.242,0,0,1,21.044,12.4M18.81,11.321h-.02a.556.556,0,0,0-.392.171.55.55,0,0,0-.156.4.569.569,0,1,0,.568-.567m0-8.553a.569.569,0,1,0,0-1.137h-.02a.557.557,0,0,0-.548.567.569.569,0,0,0,.568.571m-8.3,3.708h-.021a.558.558,0,0,0-.548.567.569.569,0,1,0,.569-.567m3.584,7.787v4.969H11.321V22H2.769V19.231H0V14.263a2.211,2.211,0,0,1,2.2-2.2h.569V9.294H6.912v1.631H4.4v1.137h7.489a2.213,2.213,0,0,1,2.2,2.2m-2.769,1.953V17.6h1.137V14.263a.569.569,0,0,0-.57-.569H2.2a.569.569,0,0,0-.57.569V17.6H2.769V16.216ZM9.69,17.847H4.4v2.521H9.69Z"
      transform="translate(1.454 1)"
    />
  </svg>`;
export const editFilterSvg = (classes = 'fill-chm-red') => html `<svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M17.914.5a.993.993 0 0 0-.707.293L2.5 15.5v4h4L21.207 4.793a1 1 0 0 0 0-1.414L18.621.793A.993.993 0 0 0 17.914.5Zm0 2.414 1.172 1.172-1.293 1.293-1.172-1.172Zm-2.707 2.707 1.172 1.172L5.672 17.5H4.5v-1.172Zm0 0"
    />
  </svg>`;
export const bookableSvg = (classes = 'fill-chm-red') => html `<svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M10.333 2.833A1.678 1.678 0 0 0 8.667 4.5v.833H7V4.5H5.333v.833H3.667A1.678 1.678 0 0 0 2 7v12.5a1.678 1.678 0 0 0 1.667 1.667h5V19.5H7V7.833H5.333V19.5H3.667V7h16.666v3.333H22V7a1.678 1.678 0 0 0-1.667-1.667h-1.666V4.5H17v.833h-1.667V4.5a1.678 1.678 0 0 0-1.666-1.667Zm0 1.667h3.333v.833h-3.333Zm5 5a1.678 1.678 0 0 0-1.667 1.667V12H12a1.678 1.678 0 0 0-1.667 1.667V19.5A1.678 1.678 0 0 0 12 21.166h8.333A1.678 1.678 0 0 0 22 19.5v-5.834a1.678 1.678 0 0 0-1.667-1.667h-1.666v-.833A1.678 1.678 0 0 0 17 9.5Zm0 1.667H17V12h-1.667ZM12 13.666h8.333v5.833H12Zm0 0"
    />
  </svg>`;
export const listSvg = (classes = 'fill-chm-red') => html ` <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      d="M3,4.5A1.5,1.5,0,1,0,4.5,6,1.5,1.5,0,0,0,3,4.5ZM7,5V7H22V5ZM3,10.5A1.5,1.5,0,1,0,4.5,12,1.5,1.5,0,0,0,3,10.5ZM7,11v2H22V11ZM3,16.5A1.5,1.5,0,1,0,4.5,18,1.5,1.5,0,0,0,3,16.5ZM7,17v2H22V17Z"
      transform="translate(0.5)"
    />
  </svg>`;
export const undoDrawSvg = (classes = 'fill-chm-red') => html `<svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M21.415 12.301a1 1 0 0 1-1.39-.28c-2.11-3.17-5.5-4.67-8.43-3.74-2.28.72-3.72 2.82-4.06 5.72l2.84-2.07a1.002 1.002 0 0 1 1.18 1.62l-5.48 3.98-3.88-5.33a1.002 1.002 0 0 1 1.62-1.18L5.6 13.466c.49-3.56 2.41-6.15 5.4-7.1 3.78-1.2 8.08.62 10.7 4.54a1 1 0 0 1-.28 1.39"
    />
  </svg>`;
export const redoDrawSvg = (classes = 'fill-chm-red') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M24 24H0V0h24z" />
    <path
      d="m21.664 12.195-3.88 5.33-5.48-3.98a1.002 1.002 0 1 1 1.18-1.62l2.84 2.07c-.34-2.91-1.78-5-4.06-5.72-2.93-.93-6.32.58-8.43 3.74a1.003 1.003 0 0 1-1.67-1.11c2.61-3.92 6.91-5.74 10.7-4.54 2.99.95 4.91 3.54 5.4 7.1l1.78-2.45a1.002 1.002 0 1 1 1.62 1.18"
    />
  </svg>
`;
export const saveDrawSvg = (classes = 'fill-chm-red') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M12 2a10 10 0 1 0 10 10A10.015 10.015 0 0 0 12 2Zm0 2a8 8 0 1 1-8 8 7.985 7.985 0 0 1 8-8Zm4.293 4.293L10 14.586l-2.293-2.293-1.414 1.414L10 17.414l7.707-7.707Z"
    />
  </svg>
`;
export const cancelDrawSvg = (classes = 'fill-chm-red') => html `
  <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 2a10 10 0 1 0 10 10A10.015 10.015 0 0 0 12 2Zm0 2a8 8 0 0 1 6.318 12.9L7.1 5.682A7.965 7.965 0 0 1 12 4ZM5.682 7.1 16.9 18.318A8 8 0 0 1 5.682 7.1Z"
    />
    <path fill="none" d="M0 0h24v24H0z" />
  </svg>
`;
export const reverseDrawSvg = (classes = 'fill-chm-red') => html ` <svg
    class="${classes}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="m22.11 7.888-4.25 4.58a1 1 0 0 1-1.46-1.36l2.06-2.22H3a1 1 0 0 1 0-2h15.45l-2.05-2.21a1 1 0 0 1 1.46-1.36L22.11 7.9Zm-1.11 9H5.68l2.05-2.21a1 1 0 1 0-1.46-1.36L2.02 17.9l4.25 4.58a1 1 0 0 0 1.46-1.36L5.67 18.9H21a1 1 0 0 0 0-2Z"
    />
  </svg>`;
export const poiAddSvg = (classes = 'fill-chm-red') => html `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M12.58 11.426a6.976 6.976 0 0 0 1.984 1.13C13.665 17.044 8.353 23 8.353 23S2 15.89 2 11.353a6.334 6.334 0 0 1 8.043-6.118A7.234 7.234 0 0 0 10 6a6.939 6.939 0 0 0 .177 1.547 4.181 4.181 0 0 0-1.824-.429 4.238 4.238 0 0 0-4.236 4.235c0 2.134 2.2 5.679 4.236 8.322 2.009-2.619 4.181-6.112 4.227-8.249m-6.345-.073a2.118 2.118 0 1 0 2.118-2.118 2.118 2.118 0 0 0-2.118 2.118M17 1a5 5 0 1 1-5 5 5 5 0 0 1 5-5"
    />
    <path
      fill="#fff"
      d="M17.576 5.425V2.751h-1.151v2.674H13.75v1.149h2.675v2.677h1.15V6.575h2.675v-1.15Z"
    />
  </svg>
`;
export const snapActiveSvg = (classes = 'fill-chm-red') => html `<svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      d="M12.6,11.178v5.4H10.8v-5.4a3.6,3.6,0,1,0-7.2,0v5.4H1.8v-5.4a5.383,5.383,0,0,1,5.366-5.4H7.2a5.34,5.34,0,0,1,1.824.333A6.9,6.9,0,0,1,8.927,5a7.082,7.082,0,0,1,.047-.789A7.162,7.162,0,0,0,0,11.178v10.8H5.4v-10.8a1.8,1.8,0,1,1,3.6,0v10.8h5.4V11.827a6.937,6.937,0,0,1-1.8-.67Zm-9,9H1.8v-1.8H3.6Zm9,0H10.8v-1.8h1.8Z"
      transform="translate(3 0.023)"
    />
    <path
      d="M20.927,5a5,5,0,1,1-5-5,5,5,0,0,1,5,5"
      transform="translate(3.021 0.001)"
      fill="#ad091d"
    />
    <path
      d="M18.28,2.5,14.831,5.953,13.574,4.694l-.777.777L14.831,7.5l4.226-4.223Z"
      transform="translate(3.021 0.001)"
      fill="#fff"
    />
  </svg>`;
export const snapInactiveSvg = (classes = 'fill-chm-red') => html ` <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      d="M14.391,18l0-10.8A7.194,7.194,0,1,0,0,7.2V18H5.367V7.208a1.833,1.833,0,0,1,.56-1.286,1.752,1.752,0,0,1,1.3-.512A1.809,1.809,0,0,1,9.023,7.2V18Zm-1.757-1.757H10.781V14.39h1.853ZM3.609,7.2v5.439H1.757V7.192a5.439,5.439,0,0,1,10.877,0v5.438H10.781V7.182A3.549,3.549,0,0,0,7.255,3.656H7.212A3.588,3.588,0,0,0,3.609,7.2M1.757,14.39H3.609v1.853H1.758Z"
      transform="translate(3 4)"
      fill="#d4021c"
    />
  </svg>`;
export const profileSvg = (classes = 'fill-chm-red') => html `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    width="24"
    height="24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="m7.7 19.854-2.013-4.05-1.887 3.7-1.8-.917 3.707-7.291 2.073 4.17 6.144-11.319L22 18.551l-1.765.99-6.282-11.2Z"
    />
  </svg>
`;
export const importTourSvg = (classes = 'fill-chm-red') => html `<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11_10732)">
      <path
        d="M10 2C8.895 2 8 2.895 8 4V9H10V4H18V20H10V15H8V20C8 21.105 8.895 22 10 22H18C19.105 22 20 21.105 20 20V4C20 2.895 19.105 2 18 2H10ZM12 8V11H4V13H12V16L16 12L12 8Z"
        class="${classes}"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_10732">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg> `;
export const menuSvg = (classes = 'fill-chm-red w-[24px] h-[20px]') => html `<svg
    class="${classes}"
    viewBox="0 0 44 38"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0V5.42857H44V0H0ZM0 16.2857V21.7143H44V16.2857H0ZM0 32.5714V38H44V32.5714H0Z"
    />
  </svg> `;
const SVG_PATHS = {
    pdf: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V5L13 0H4ZM4 2H12V6H16V7H4V2ZM2 9H3.5C4.328 9 5 9.672 5 10.5C5 11.328 4.328 12 3.5 12H3V14H2V9ZM11 9H14V10H12V11H13.5996V12H12V14H11V9ZM6 9.02344H7.62891C9.21091 9.02344 10 9.97491 10 11.1289V11.9004C10 13.0684 9.20923 14 7.61523 14H6V9.02344ZM3 10V11H3.5C3.776 11 4 10.776 4 10.5C4 10.224 3.776 10 3.5 10H3ZM7 10.0234V13H7.61523C8.24723 13 9 12.8084 9 11.9004V11.1289C9 10.2149 8.25491 10.0234 7.62891 10.0234H7ZM4 16H16V18H4V16Z',
    doc: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V14V9V5L13 0H4ZM4 2H12V6H16V7H4V2ZM14 9C15.105 9 16 9.895 16 11H15C15 10.449 14.551 10 14 10C13.449 10 13 10.449 13 11V12C13 12.551 13.449 13 14 13C14.551 13 15 12.551 15 12H16C16 13.105 15.105 14 14 14C12.895 14 12 13.105 12 12V11C12 9.895 12.895 9 14 9ZM2 9.02344H3.62891C5.21191 9.02344 6 9.97491 6 11.1289V11.9004C6 13.0684 5.20923 14 3.61523 14H2V9.02344ZM9 9.06445C10.864 9.03445 11 10.8424 11 11.1914V12C11 12.342 10.9138 14.1015 9.00781 14.0605C6.96681 14.0185 7 12.342 7 12V11.1914C7 10.8404 7.167 9.09345 9 9.06445ZM9.00195 9.88672C8.05695 9.90572 8 10.9535 8 11.1855V12C8 12.222 8.15472 13.2592 9.01172 13.2422C9.83372 13.2272 10 12.221 10 12V11.1855C10 10.9535 9.88795 9.86872 9.00195 9.88672ZM3 10.0234V13H3.61523C4.24723 13 5 12.8084 5 11.9004V11.1289C5 10.2149 4.25491 10.0234 3.62891 10.0234H3ZM4 16H16V18H4V16Z',
    eps: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V5L13 0H4ZM4 2H12V6H16V18H4V16H13C14.105 16 15 15.105 15 14V9C15 7.895 14.105 7 13 7H4V2ZM2 9H5V10H3V11H4.59961V12H3V13H5V14H2V9ZM6 9H7.5C8.328 9 9 9.672 9 10.5C9 11.328 8.328 12 7.5 12H7V14H6V9ZM11.4902 9C12.9132 9.041 13 10.2829 13 10.5039H12.0312C12.0312 10.4009 12.0487 9.80664 11.4727 9.80664C11.2977 9.80664 10.9055 9.88419 10.9355 10.3672C10.9645 10.8102 11.5473 11.0194 11.6543 11.0664C11.8783 11.1484 12.9871 11.6424 12.9961 12.6504C12.9981 12.8644 12.9428 13.985 11.5098 14C9.95077 14.017 9.8457 12.6754 9.8457 12.3984H10.8203C10.8203 12.5454 10.8328 13.2562 11.5098 13.2012C11.9168 13.1672 12.0055 12.8743 12.0195 12.6562C12.0425 12.2893 11.6923 12.0686 11.3223 11.8906C10.8023 11.6406 9.97984 11.3334 9.96484 10.3594C9.95184 9.48238 10.5962 8.975 11.4902 9ZM7 10V11H7.5C7.776 11 8 10.776 8 10.5C8 10.224 7.776 10 7.5 10H7Z',
    jpg: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V5L13 0H4ZM4 2H12V6H16V7H4V2ZM4 9H5V12.5C5 13.328 4.328 14 3.5 14C2.672 14 2 13.328 2 12.5H3C3 12.776 3.224 13 3.5 13C3.776 13 4 12.776 4 12.5V9ZM6 9H7.5C8.328 9 9 9.672 9 10.5C9 11.328 8.328 12 7.5 12H7V14H6V9ZM12.0352 9.00195C13.2072 9.00295 13.6733 9.53895 13.8633 10.002H12.5703H12C11.118 9.98895 11 10.8569 11 11.0859V11.9141C11 12.1461 11.2068 13.012 12.1758 13.002C12.4588 12.999 12.976 12.8363 13 12.8223L12.9785 12H12L12.0215 11H14V13.3809C13.94 13.4369 13.2914 13.961 12.1074 13.998C11.7854 14.008 10.132 14.0381 10 11.9141V11.0918C10 10.7368 9.95816 8.99995 12.0352 9.00195ZM7 10V11H7.5C7.776 11 8 10.776 8 10.5C8 10.224 7.776 10 7.5 10H7ZM4 16H16V18H4V16Z',
    png: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V5L13 0H4ZM4 2H12V6H16V7H4V2ZM2 9H3.5C4.328 9 5 9.672 5 10.5C5 11.328 4.328 12 3.5 12H3V14H2V9ZM9 9H10V14H8.8457L7 10.7363V14H6V9.02344H7.1543L9 12.2676V9ZM13.0352 9.00195C14.2072 9.00295 14.6733 9.53895 14.8633 10.002H13C12.118 9.98895 12 10.8569 12 11.0859V11.9141C12 12.1461 12.2068 13.012 13.1758 13.002C13.4588 12.999 13.976 12.8363 14 12.8223L13.9785 12H13L13.0215 11H15V13.3809C14.94 13.4369 14.2914 13.961 13.1074 13.998C12.7854 14.008 11.132 14.0381 11 11.9141V11.0918C11 10.7368 10.9582 8.99995 13.0352 9.00195ZM3 10V11H3.5C3.776 11 4 10.776 4 10.5C4 10.224 3.776 10 3.5 10H3ZM4 16H16V18H4V16Z',
    ppt: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V5L13 0H4ZM4 2H12V6H16V18H4V16H13C14.105 16 15 15.105 15 14V9C15 7.895 14.105 7 13 7H4V2ZM2 9H3.5C4.328 9 5 9.672 5 10.5C5 11.328 4.328 12 3.5 12H3V14H2V9ZM6 9H7.5C8.328 9 9 9.672 9 10.5C9 11.328 8.328 12 7.5 12H7V14H6V9ZM10 9H13V10H12V14H11V10H10V9ZM3 10V11H3.5C3.776 11 4 10.776 4 10.5C4 10.224 3.776 10 3.5 10H3ZM7 10V11H7.5C7.776 11 8 10.776 8 10.5C8 10.224 7.776 10 7.5 10H7Z',
    xlsx: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V5L13 0H4ZM4 2H12V6H16V7H4V2ZM2.02539 9H3.27344L3.99805 10.7168L4.72461 9H5.9707L4.70312 11.4785L6 14H4.73828L3.99805 12.252L3.26172 14H2L3.29492 11.4785L2.02539 9ZM7 9H8V13H10V14H7V9ZM12.4902 9C13.9132 9.041 14 10.2829 14 10.5039H13.0312C13.0312 10.4009 13.0487 9.80664 12.4727 9.80664C12.2977 9.80664 11.9055 9.88419 11.9355 10.3672C11.9645 10.8102 12.5473 11.0194 12.6543 11.0664C12.8783 11.1484 13.9871 11.6424 13.9961 12.6504C13.9981 12.8644 13.9428 13.985 12.5098 14C10.9508 14.017 10.8457 12.6754 10.8457 12.3984H11.8203C11.8203 12.5454 11.8328 13.2562 12.5098 13.2012C12.9168 13.1672 13.0055 12.8743 13.0195 12.6562C13.0425 12.2893 12.6923 12.0686 12.3223 11.8906C11.8023 11.6406 10.9798 11.3334 10.9648 10.3594C10.9518 9.48238 11.5962 8.975 12.4902 9ZM4 16H16V18H4V16Z',
    zip: 'M4 0C2.90575 0 2 0.905745 2 2V7C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16V18C2 19.0943 2.90575 20 4 20H16C17.0943 20 18 19.0943 18 18V5L13 0H4ZM4 2H12V6H16V18H4V16H11C12.105 16 13 15.105 13 14V9C13 7.895 12.105 7 11 7H4V2ZM2 9H5V10L3.32422 13H5V14H2V13L3.70508 10H2V9ZM5.99414 9H7V14H5.99414V9ZM8 9H9H9.5C10.328 9 11 9.672 11 10.5C11 11.328 10.328 12 9.5 12H9V14H8V12V9ZM9 10V11H9.5C9.776 11 10 10.776 10 10.5C10 10.224 9.776 10 9.5 10H9Z',
};
export function fileDownloadSvg(classes, fileType) {
    if (Object.keys(SVG_PATHS).includes(fileType)) {
        return html `<svg
      class="${classes}"
      viewBox="0 0 18 20"
      width="18"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d=${SVG_PATHS[fileType]} fill="black" />
    </svg>`;
    }
    else {
        return downloadSvg('fill-black');
    }
}
export const resetFilterSvg = (classes = 'fill-chm-red hover:fill-black') => html ` <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
  >
    <path
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12H20C20 16.411 16.411 20 12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C14.206 4 16.2027 4.90048 17.6504 6.34961L15 9H22V2L19.0605 4.93945C17.2518 3.12627 14.7573 2 12 2Z"
    />
  </svg>`;
export const collapseArrowSvg = (classes) => html `<svg
    class="${classes}"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M9 5 5 1 1 5"
    />
  </svg>`;
export const importToListSvg = (classes) => html `
  <svg
    class=${classes}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.08 22.43H5C3.35 22.43 2 21.07 2 19.41V11.45C2 9.78 3.35 8.43 5 8.43H6.1V10.43H5C4.45 10.43 4 10.89 4 11.45V19.41C4 19.97 4.45 20.43 5 20.43H19.08C19.63 20.43 20.08 19.97 20.08 19.41V11.45C20.08 10.89 19.63 10.43 19.08 10.43H18.06V8.43H19.08C20.73 8.43 22.08 9.78 22.08 11.45V19.41C22.08 21.08 20.73 22.43 19.08 22.43ZM7.53 6.86L12.12 11.1L16.69 6.86L15.33 5.39L13.13 7.43V2H11.13V7.46L8.9 5.39L7.54 6.86H7.53ZM8.1 15.16C7.62 15.16 7.22 15.55 7.22 16.04C7.22 16.53 7.61 16.92 8.1 16.92C8.42 16.92 8.7 16.75 8.85 16.5C8.93 16.37 8.98 16.21 8.98 16.05C8.98 15.57 8.59 15.17 8.1 15.17V15.16ZM17.05 15.54H9.8V16.54H17.05V15.54ZM8.1 17.65C7.62 17.65 7.22 18.04 7.22 18.53C7.22 19.02 7.61 19.41 8.1 19.41C8.42 19.41 8.7 19.24 8.85 18.99C8.93 18.86 8.98 18.7 8.98 18.54C8.98 18.06 8.59 17.66 8.1 17.66V17.65ZM9.8 18.03V19.03H17.05V18.03H9.8ZM18.05 11.57V14.45H6.03V11.57H18.05ZM8.84 13.06C8.84 12.58 8.45 12.18 7.96 12.18C7.47 12.18 7.08 12.57 7.08 13.06C7.08 13.55 7.47 13.94 7.96 13.94C8.28 13.94 8.56 13.77 8.71 13.52C8.79 13.39 8.84 13.23 8.84 13.07V13.06ZM17.05 12.52H9.8V13.52H17.05V12.52Z"
    />
  </svg>
`;
export const rocketSvg = (classes) => html `
  <svg
    class=${classes}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3471 2.01128C21.2074 1.996 21.0629 1.99678 20.9174 2.01714C18.7463 2.3223 13.702 3.15554 8.69865 8.99957H6.05607L3.38029 11.7847C3.00829 12.1567 2.89704 12.7118 3.09904 13.1988C3.30004 13.6858 3.77126 13.9996 4.29826 13.9996H6.56779L6.67131 14.1031C6.39812 14.4476 6.24364 14.812 6.08928 15.2125C5.90124 15.7003 5.74467 16.2316 5.61467 16.732C5.35466 17.7328 5.2006 18.6246 5.2006 18.6246L4.95256 20.0289L6.35685 19.7808C6.35685 19.7808 7.24858 19.6268 8.24943 19.3668C8.74986 19.2367 9.28108 19.0802 9.76896 18.8921C10.1695 18.7378 10.5339 18.5833 10.8783 18.3101L10.9819 18.4136V20.6832C10.9819 21.2102 11.2956 21.6824 11.7826 21.8824C11.9476 21.9514 12.1195 21.982 12.2885 21.982C12.6195 21.982 12.9395 21.8593 13.1635 21.6343L15.9819 19.066V16.2828C21.8259 11.2794 22.6591 6.23513 22.9643 4.06402C23.1068 3.04553 22.3248 2.11825 21.3471 2.01128ZM20.935 4.04644C20.5778 6.58963 19.7726 11.5814 12.1069 16.7105L8.27092 12.8746C13.4 5.20878 18.3918 4.40365 20.935 4.04644ZM15.9819 7.99957C15.4296 7.99957 14.9819 8.44728 14.9819 8.99957C14.9819 9.55185 15.4296 9.99957 15.9819 9.99957C16.5341 9.99957 16.9819 9.55185 16.9819 8.99957C16.9819 8.44728 16.5341 7.99957 15.9819 7.99957ZM12.9819 10.9996C12.4296 10.9996 11.9819 11.4473 11.9819 11.9996C11.9819 12.5518 12.4296 12.9996 12.9819 12.9996C13.5341 12.9996 13.9819 12.5518 13.9819 11.9996C13.9819 11.4473 13.5341 10.9996 12.9819 10.9996ZM8.13029 15.5621L9.41935 16.8511C9.31234 16.9078 9.19733 16.9695 9.04826 17.0269C8.67337 17.1714 8.20022 17.3111 7.74553 17.4293C7.61547 17.463 7.6219 17.454 7.49748 17.4839C7.52739 17.3595 7.51838 17.3659 7.55217 17.2359C7.67029 16.7812 7.81002 16.3081 7.95451 15.9332C8.01196 15.7841 8.07364 15.6691 8.13029 15.5621Z"
    />
  </svg>
`;
export const thumbsUpSvg = (classes) => html ` <svg
    fill="#000000"
    class="${classes}"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3,10.08A3,3,0,0,0,19,9H14.44L15,7.57A4.13,4.13,0,0,0,11.11,2a1,1,0,0,0-.91.59L7.35,9H5a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17.73a3,3,0,0,0,2.95-2.46l1.27-7A3,3,0,0,0,21.3,10.08ZM7,20H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H7Zm13-7.82-1.27,7a1,1,0,0,1-1,.82H9V10.21l2.72-6.12A2.11,2.11,0,0,1,13.1,6.87L12.57,8.3A2,2,0,0,0,14.44,11H19a1,1,0,0,1,.77.36A1,1,0,0,1,20,12.18Z"
    />
  </svg>`;
export const thumbsDownSvg = (classes) => html `<svg
    fill="#000000"
    class="${classes}"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19,2H6.27A3,3,0,0,0,3.32,4.46l-1.27,7A3,3,0,0,0,5,15H9.56L9,16.43A4.13,4.13,0,0,0,12.89,22a1,1,0,0,0,.91-.59L16.65,15H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2ZM15,13.79l-2.72,6.12a2.13,2.13,0,0,1-1.38-2.78l.53-1.43A2,2,0,0,0,9.56,13H5a1,1,0,0,1-.77-.36A1,1,0,0,1,4,11.82l1.27-7a1,1,0,0,1,1-.82H15ZM20,12a1,1,0,0,1-1,1H17V4h2a1,1,0,0,1,1,1Z"
    />
  </svg>`;
export const magicSparklesSvg = (classes) => html `<svg
    fill="#000000"
    width="20px"
    height="20px"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title />

    <g data-name="Layer 2" id="Layer_2">
      <path
        d="M18,11a1,1,0,0,1-1,1,5,5,0,0,0-5,5,1,1,0,0,1-2,0,5,5,0,0,0-5-5,1,1,0,0,1,0-2,5,5,0,0,0,5-5,1,1,0,0,1,2,0,5,5,0,0,0,5,5A1,1,0,0,1,18,11Z"
      />

      <path
        d="M19,24a1,1,0,0,1-1,1,2,2,0,0,0-2,2,1,1,0,0,1-2,0,2,2,0,0,0-2-2,1,1,0,0,1,0-2,2,2,0,0,0,2-2,1,1,0,0,1,2,0,2,2,0,0,0,2,2A1,1,0,0,1,19,24Z"
      />

      <path
        d="M28,17a1,1,0,0,1-1,1,4,4,0,0,0-4,4,1,1,0,0,1-2,0,4,4,0,0,0-4-4,1,1,0,0,1,0-2,4,4,0,0,0,4-4,1,1,0,0,1,2,0,4,4,0,0,0,4,4A1,1,0,0,1,28,17Z"
      />
    </g>
  </svg>`;
export const closedWaySvg = (classes = 'w-[22px] h-[22px] shrink-0') => html `
  <svg
    class="${classes}"
    width="22"
    height="22"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
  >
    <path
      fill="#e53027"
      d="M11,0c6.08,0,11,4.92,11,11s-4.92,11-11,11S0,17.08,0,11,4.92,0,11,0h0"
    />
    <path
      fill="#fff"
      d="M11,3.67c1,0,1.95,.19,2.85,.57,.88,.37,1.65,.9,2.33,1.57,.68,.68,1.2,1.46,1.57,2.33,.38,.91,.57,1.86,.57,2.85s-.19,1.95-.57,2.85c-.37,.88-.9,1.65-1.57,2.33-.68,.68-1.46,1.2-2.33,1.57-.91,.38-1.86,.57-2.85,.57s-1.95-.19-2.85-.57c-.88-.37-1.65-.9-2.33-1.57-.68-.68-1.2-1.46-1.57-2.33-.38-.91-.57-1.86-.57-2.85s.19-1.95,.57-2.85c.37-.88,.9-1.65,1.57-2.33,.68-.68,1.46-1.2,2.33-1.57,.91-.38,1.86-.57,2.85-.57h0"
    />
    <path
      fill="#1d1d1b"
      d="M13.35,10.98h-.16l.02,.05h0v.03h.01c.04,.08,.07,.04,.1,.15,.03,.12,0,.27-.07,.32-.04,.03-.11,.01-.13,.01-.1-.01-.22-.06-.26-.16-.01-.03-.01-.07-.01-.1,0-.05,0-.14,0-.2,0-.03,0-.06,0-.09h-.12l-.16-1.49-.62-.6,.07,1.62,.53,1.13-.23,.14,.61,1.63,1.3,2.33-.1,.06h0s.01,.03,.02,.03h0l.05,.04h0s.04,.04,.05,.06c.01,.03,.03,.06,.04,.09,0,.02,0,.06,0,.07,0,.01,0,.05,0,.06,0,.02,0,.04,0,.06h0l-.57,.22h-.63v-.09h0s0-.02,0-.04c0-.02,0-.04,.01-.06,0-.02,.02-.04,.04-.06,.02-.02,.06-.03,.08-.04,.02,0,.06-.02,.08-.03h0l.07-.02h0s.04-.01,.06-.03c.02-.01,.04-.02,.05-.04,.01-.01,.02-.03,.02-.05,0-.01,0-.03,.01-.05h0l-.12,.04-1.27-2.06-.88-1.86-1.18,3.9-.07-.02-.11,.51-1.11-.32h0s-.01-.03-.01-.04c0-.02,0-.04,.01-.05,.01-.02,.03-.04,.04-.06,.02-.02,.05-.03,.08-.04,.03,0,.06-.01,.09-.02h.23s.07-.01,.09-.01c.02,0,.06,0,.08-.02,.01-.01,.03-.03,.04-.04,.02-.03,.03-.07,.04-.1h0l-.3-.13,.89-3.76-.14-.06,.22-1.37-.35-.98-.22,.32-.06,.08-.09,.07-1.05,.85-.06-.08h0s0,.02,0,.03c0,.02,0,.04-.01,.06h0v.06h0s0,.04-.01,.06c0,.01-.03,.03-.04,.04-.02,.01-.04,.02-.06,.02h-.05s-.09,.04-.12,.07h0l-.06,.06h0s-.05,.04-.08,.05c-.05,0-.1-.02-.12-.06-.05-.08-.01-.2,0-.3,0-.05,.02-.1,.05-.14,.02-.04,.04-.07,.07-.09h0l.08-.06,.06-.05h0s.04-.03,.05-.04h0l-.06-.1,1.04-.94,.45-1.78h0c.06-.25,.17-.25,.27-.28h0l.51-.16h0c0-.08-.06-.16-.14-.17-.01,0-.08-.02-.1-.02-.04-.01-.09-.02-.11-.06-.04-.04-.02-.18-.03-.22,0-.01,0-.05-.03-.07h-.03s-.02-.03-.03-.05c0-.01,0-.03,0-.04,0-.03,.05-.07,.06-.09l.04-.07s-.01-.06-.01-.09c0-.04,0-.11,0-.15h0l-.29-.03,.03-.14h.29s.02-.11,.03-.13h0l.02-.08h0s.06-.18,.08-.21c.02-.03,.08-.09,.12-.09,.05,0,.15,.02,.2,.04,.05,.01,.12,.04,.16,.04,.01,0,.05-.01,.07-.02,.08-.03,.18-.03,.26-.02,.06,0,.12,.04,.15,.1,.04,.08,.05,.2,.07,.28h0l.18,.02v.18h-.24s.01,.11,.01,.16c0,.08-.02,.16-.05,.23h0l-.11,.25h0c-.01,.06,0,.12,.04,.17,.02,.03,.05,.06,.07,.08h0l.17-.02h0c.11,0,.18,.03,.28,.14h0l1.54,1.6h0c.1,.11,.18,.29,.2,.47h0l.18,1.78h0"
    />
  </svg>
`;
export const greyElevationSvg = () => html `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1.92578 19.8428L5.01471 13.7656L7.27441 18.3115L14.1268 5.6875L22.0649 19.8428"
      stroke="#7B7B7B"
      stroke-width="2"
    />
    <circle cx="14" cy="4" r="2" fill="#7B7B7B" />
  </svg>`;
export function renderDescription(str, indx) {
    const match = str.match(/^#\s?(.*)/);
    if (match) {
        return html `<h3 class="h3 ${classMap({ 'mt-4': indx !== 0 })}">
      ${match[1]}
    </h3>`;
    }
    else {
        return html `<p class="body ${classMap({ 'mt-4': indx !== 0 })}">${str}</p>`;
    }
}
export const DETOUR_BG_COLOR = {
    closed_way: 'bg-detour',
    detour: 'bg-chm-tertiary-gray',
    closed_way_detour: 'bg-chm-tertiary-gray',
};
export const DETOUR_TYPE_TRANSLATIONS = {
    closed_way: `Chiusura`,
    detour: `Deviazione`,
    closed_way_detour: `Chiusura con deviazione`,
};
//# sourceMappingURL=elements.js.map